//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    token(userLogin: UserLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CartClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getCart(): Observable<CartDTO> {
        let url_ = this.baseUrl + "/api/v1/Cart/GetCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDTO>;
        }));
    }

    protected processGetCart(response: HttpResponseBase): Observable<CartDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addToCart(addToCartDto: AddToCartDTO): Observable<CartDTO> {
        let url_ = this.baseUrl + "/api/v1/Cart/AddToCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addToCartDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDTO>;
        }));
    }

    protected processAddToCart(response: HttpResponseBase): Observable<CartDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCartItem(updateCartItemDto: UpdateCartItemDTO): Observable<CartDTO> {
        let url_ = this.baseUrl + "/api/v1/Cart/UpdateCartItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCartItemDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDTO>;
        }));
    }

    protected processUpdateCartItem(response: HttpResponseBase): Observable<CartDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeFromCart(removeFromCartDto: RemoveFromCartDTO): Observable<CartDTO> {
        let url_ = this.baseUrl + "/api/v1/Cart/RemoveFromCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeFromCartDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFromCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFromCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDTO>;
        }));
    }

    protected processRemoveFromCart(response: HttpResponseBase): Observable<CartDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clearCart(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/Cart/ClearCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processClearCart(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkout(checkoutDto: CheckoutDTO): Observable<OrderDTO> {
        let url_ = this.baseUrl + "/api/v1/Cart/Checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkoutDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDTO>;
        }));
    }

    protected processCheckout(response: HttpResponseBase): Observable<OrderDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getCategory(id: number | undefined): Observable<CategoryDTO> {
        let url_ = this.baseUrl + "/api/v1/Category/GetCategory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO>;
        }));
    }

    protected processGetCategory(response: HttpResponseBase): Observable<CategoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCategory(createCategoryDto: CreateCategoryDTO): Observable<CategoryDTO> {
        let url_ = this.baseUrl + "/api/v1/Category/CreateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCategoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO>;
        }));
    }

    protected processCreateCategory(response: HttpResponseBase): Observable<CategoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCategory(id: number | undefined, updateCategoryDto: UpdateCategoryDTO): Observable<CategoryDTO> {
        let url_ = this.baseUrl + "/api/v1/Category/UpdateCategory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCategoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO>;
        }));
    }

    protected processUpdateCategory(response: HttpResponseBase): Observable<CategoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCategory(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Category/DeleteCategory?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCategories(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfCategoryDTO> {
        let url_ = this.baseUrl + "/api/v1/Category/SearchCategories?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfCategoryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfCategoryDTO>;
        }));
    }

    protected processSearchCategories(response: HttpResponseBase): Observable<PagedResultDTOOfCategoryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfCategoryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    createClient(client: CreateClientDTO): Observable<ClientDTO | null> {
        let url_ = this.baseUrl + "/api/v1/Client/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO | null>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<ClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Client/DeactivateClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClient(id: number | undefined): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/v1/Client/GetClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchClients(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfClientDTO | null> {
        let url_ = this.baseUrl + "/api/v1/Client/SearchClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO | null>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(client: UpdateClientDTO): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/v1/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getSellerOverview(sellerProfileId: number | undefined): Observable<SellerOverviewDTO> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetSellerOverview?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellerOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellerOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerOverviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerOverviewDTO>;
        }));
    }

    protected processGetSellerOverview(response: HttpResponseBase): Observable<SellerOverviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellerOverviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWeeklyPerformance(sellerProfileId: number | undefined): Observable<WeeklyPerformanceDTO> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetWeeklyPerformance?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeeklyPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeeklyPerformanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeeklyPerformanceDTO>;
        }));
    }

    protected processGetWeeklyPerformance(response: HttpResponseBase): Observable<WeeklyPerformanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeeklyPerformanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTopProducts(sellerProfileId: number | undefined): Observable<TopProductDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetTopProducts?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopProductDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopProductDTO[]>;
        }));
    }

    protected processGetTopProducts(response: HttpResponseBase): Observable<TopProductDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopProductDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLowStockAlerts(sellerProfileId: number | undefined): Observable<AlertDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetLowStockAlerts?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLowStockAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLowStockAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDTO[]>;
        }));
    }

    protected processGetLowStockAlerts(response: HttpResponseBase): Observable<AlertDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExpiryAlerts(sellerProfileId: number | undefined): Observable<AlertDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetExpiryAlerts?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpiryAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpiryAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDTO[]>;
        }));
    }

    protected processGetExpiryAlerts(response: HttpResponseBase): Observable<AlertDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInventoryPerformance(sellerProfileId: number | undefined): Observable<InventoryPerformanceDTO> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetInventoryPerformance?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryPerformanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryPerformanceDTO>;
        }));
    }

    protected processGetInventoryPerformance(response: HttpResponseBase): Observable<InventoryPerformanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryPerformanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliveryPerformance(sellerProfileId: number | undefined): Observable<DeliveryPerformanceDTO> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/GetDeliveryPerformance?";
        if (sellerProfileId === null)
            throw new globalThis.Error("The parameter 'sellerProfileId' cannot be null.");
        else if (sellerProfileId !== undefined)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryPerformanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryPerformanceDTO>;
        }));
    }

    protected processGetDeliveryPerformance(response: HttpResponseBase): Observable<DeliveryPerformanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryPerformanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeliveryPlanClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    createDeliveryPlan(createDto: CreateDeliveryPlanDTO): Observable<DeliveryPlanDTO> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/CreateDeliveryPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryPlanDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryPlanDTO>;
        }));
    }

    protected processCreateDeliveryPlan(response: HttpResponseBase): Observable<DeliveryPlanDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryPlanDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliveryPlan(id: number | undefined, latitude: number | null | undefined, longitude: number | null | undefined): Observable<DeliveryPlanDTO> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/GetDeliveryPlan?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryPlanDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryPlanDTO>;
        }));
    }

    protected processGetDeliveryPlan(response: HttpResponseBase): Observable<DeliveryPlanDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryPlanDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDeliveryPlan(deliveryPlanId: number | undefined, updateDto: UpdateDeliveryStatusDTO): Observable<DeliveryPlanDTO> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/UpdateDeliveryPlan?";
        if (deliveryPlanId === null)
            throw new globalThis.Error("The parameter 'deliveryPlanId' cannot be null.");
        else if (deliveryPlanId !== undefined)
            url_ += "deliveryPlanId=" + encodeURIComponent("" + deliveryPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryPlanDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryPlanDTO>;
        }));
    }

    protected processUpdateDeliveryPlan(response: HttpResponseBase): Observable<DeliveryPlanDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryPlanDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDeliveryStatus(deliveryPlanId: number | undefined, status: DeliveryStatus): Observable<DeliveryPlanDTO> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/UpdateDeliveryStatus?";
        if (deliveryPlanId === null)
            throw new globalThis.Error("The parameter 'deliveryPlanId' cannot be null.");
        else if (deliveryPlanId !== undefined)
            url_ += "deliveryPlanId=" + encodeURIComponent("" + deliveryPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryPlanDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryPlanDTO>;
        }));
    }

    protected processUpdateDeliveryStatus(response: HttpResponseBase): Observable<DeliveryPlanDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryPlanDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDeliveryPlan(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/DeleteDeliveryPlan?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDeliveryPlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchDeliveryPlans(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfDeliveryPlanDTO> {
        let url_ = this.baseUrl + "/api/v1/DeliveryPlan/SearchDeliveryPlans?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDeliveryPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDeliveryPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfDeliveryPlanDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfDeliveryPlanDTO>;
        }));
    }

    protected processSearchDeliveryPlans(response: HttpResponseBase): Observable<PagedResultDTOOfDeliveryPlanDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfDeliveryPlanDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeviceInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    registerDeviceInfo(model: RegisterDeviceInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/RegisterDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDeviceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDeviceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterDeviceInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unregisterDeviceInfo(model: UnregisterDeviceInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/UnregisterDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnregisterDeviceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisterDeviceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnregisterDeviceInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDevicePreferences(model: UpdateDevicePreferencesDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/UpdateDevicePreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDevicePreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDevicePreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDevicePreferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InAppNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getNotifications(skip: number | undefined, take: number | undefined): Observable<InAppNotificationDTO[]> {
        let url_ = this.baseUrl + "/api/v1/InAppNotification/GetNotifications?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InAppNotificationDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InAppNotificationDTO[]>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<InAppNotificationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InAppNotificationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnreadCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/InAppNotification/GetUnreadCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnreadCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAsRead(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/InAppNotification/MarkAsRead?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAllAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/InAppNotification/MarkAllAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    searchInvoice(filter: InvoiceFilterDTO | undefined, skip: number | undefined, take: number | undefined): Observable<InvoiceOverviewDTO> {
        let url_ = this.baseUrl + "/api/v1/Invoice/SearchInvoice?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceOverviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceOverviewDTO>;
        }));
    }

    protected processSearchInvoice(response: HttpResponseBase): Observable<InvoiceOverviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceOverviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoice(id: number | undefined): Observable<InvoiceDTO> {
        let url_ = this.baseUrl + "/api/v1/Invoice/GetInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recordPayment(id: number | undefined, dto: RecordPaymentDTO): Observable<InvoiceDTO> {
        let url_ = this.baseUrl + "/api/v1/Invoice/RecordPayment?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO>;
        }));
    }

    protected processRecordPayment(response: HttpResponseBase): Observable<InvoiceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelInvoice(id: number | undefined): Observable<InvoiceDTO> {
        let url_ = this.baseUrl + "/api/v1/Invoice/CancelInvoice?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO>;
        }));
    }

    protected processCancelInvoice(response: HttpResponseBase): Observable<InvoiceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverdueInvoices(): Observable<InvoiceDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Invoice/GetOverdueInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverdueInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverdueInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO[]>;
        }));
    }

    protected processGetOverdueInvoices(response: HttpResponseBase): Observable<InvoiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    triggerBillingJob(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/Invoice/TriggerBillingJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerBillingJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerBillingJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processTriggerBillingJob(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NearbyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getNearbyUsers(request: NearbyUsersRequestDTO): Observable<NearbyUserDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Nearby/GetNearbyUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNearbyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearbyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NearbyUserDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NearbyUserDTO[]>;
        }));
    }

    protected processGetNearbyUsers(response: HttpResponseBase): Observable<NearbyUserDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NearbyUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchNearbyUsers(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfNearbyUserDTO> {
        let url_ = this.baseUrl + "/api/v1/Nearby/SearchNearbyUsers?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchNearbyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchNearbyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfNearbyUserDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfNearbyUserDTO>;
        }));
    }

    protected processSearchNearbyUsers(response: HttpResponseBase): Observable<PagedResultDTOOfNearbyUserDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfNearbyUserDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSuggestedUsers(): Observable<NearbyUserDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Nearby/GetSuggestedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NearbyUserDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NearbyUserDTO[]>;
        }));
    }

    protected processGetSuggestedUsers(response: HttpResponseBase): Observable<NearbyUserDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NearbyUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getEligibleDeliveryOrders(sellerProfileId?: number, search?: string, status?: number, assignment?: string, eligibleOnly?: boolean, skip?: number, take?: number, from?: string, to?: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/Order/GetEligibleDeliveryOrders?";
        if (sellerProfileId !== undefined && sellerProfileId !== null)
            url_ += "sellerProfileId=" + encodeURIComponent("" + sellerProfileId) + "&";
        if (search)
            url_ += "search=" + encodeURIComponent(search) + "&";
        if (from)
            url_ += "from=" + encodeURIComponent(from) + "&";
        if (to)
            url_ += "to=" + encodeURIComponent(to) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ += "assignment=" + encodeURIComponent(assignment || "unassigned") + "&";
        url_ += "eligibleOnly=" + encodeURIComponent("" + (eligibleOnly ?? true)) + "&";
        url_ += "skip=" + encodeURIComponent("" + (skip ?? 0)) + "&";
        url_ += "take=" + encodeURIComponent("" + (take ?? 50)) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return this.http.get(url_);
    }

    getOrder(id: number | undefined): Observable<OrderDTO> {
        let url_ = this.baseUrl + "/api/v1/Order/GetOrder?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDTO>;
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<OrderDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyOrders(): Observable<BuyerOrderSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Order/GetMyOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuyerOrderSummaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuyerOrderSummaryDTO[]>;
        }));
    }

    protected processGetMyOrders(response: HttpResponseBase): Observable<BuyerOrderSummaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuyerOrderSummaryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSellerOrders(): Observable<SellerOrderSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Order/GetSellerOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellerOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellerOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerOrderSummaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerOrderSummaryDTO[]>;
        }));
    }

    protected processGetSellerOrders(response: HttpResponseBase): Observable<SellerOrderSummaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellerOrderSummaryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOrderStatus(updateOrderStatusDto: UpdateOrderStatusDTO): Observable<OrderDTO> {
        let url_ = this.baseUrl + "/api/v1/Order/UpdateOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderStatusDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDTO>;
        }));
    }

    protected processUpdateOrderStatus(response: HttpResponseBase): Observable<OrderDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelOrder(cancelOrderDto: CancelOrderDTO): Observable<OrderDTO> {
        let url_ = this.baseUrl + "/api/v1/Order/CancelOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cancelOrderDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDTO>;
        }));
    }

    protected processCancelOrder(response: HttpResponseBase): Observable<OrderDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchOrder(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfOrderLimitedDTO> {
        let url_ = this.baseUrl + "/api/v1/Order/SearchOrder?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfOrderLimitedDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfOrderLimitedDTO>;
        }));
    }

    protected processSearchOrder(response: HttpResponseBase): Observable<PagedResultDTOOfOrderLimitedDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfOrderLimitedDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OTPClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    requestOTP(model: OTPRequestDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/OTP/RequestOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRequestOTP(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyOTP(model: OTPVerificationDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/OTP/VerifyOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processVerifyOTP(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PrivacyPolicyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getAllPrivacyPolicies(): Observable<PrivacyPolicyDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PrivacyPolicy/GetAllPrivacyPolicies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPrivacyPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPrivacyPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrivacyPolicyDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrivacyPolicyDTO[]>;
        }));
    }

    protected processGetAllPrivacyPolicies(response: HttpResponseBase): Observable<PrivacyPolicyDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrivacyPolicyDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestPrivacyPolicy(): Observable<PrivacyPolicyDTO> {
        let url_ = this.baseUrl + "/api/v1/PrivacyPolicy/GetLatestPrivacyPolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPrivacyPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPrivacyPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrivacyPolicyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrivacyPolicyDTO>;
        }));
    }

    protected processGetLatestPrivacyPolicy(response: HttpResponseBase): Observable<PrivacyPolicyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivacyPolicyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPrivacyPolicy(createDto: CreatePrivacyPolicyDTO): Observable<PrivacyPolicyDTO> {
        let url_ = this.baseUrl + "/api/v1/PrivacyPolicy/CreatePrivacyPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePrivacyPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrivacyPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrivacyPolicyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrivacyPolicyDTO>;
        }));
    }

    protected processCreatePrivacyPolicy(response: HttpResponseBase): Observable<PrivacyPolicyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivacyPolicyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePrivacyPolicy(updateDto: UpdatePrivacyPolicyDTO): Observable<PrivacyPolicyDTO> {
        let url_ = this.baseUrl + "/api/v1/PrivacyPolicy/UpdatePrivacyPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrivacyPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrivacyPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrivacyPolicyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrivacyPolicyDTO>;
        }));
    }

    protected processUpdatePrivacyPolicy(response: HttpResponseBase): Observable<PrivacyPolicyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivacyPolicyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptPrivacyPolicy(): Observable<UserAcceptanceDTO> {
        let url_ = this.baseUrl + "/api/v1/PrivacyPolicy/AcceptPrivacyPolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptPrivacyPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptPrivacyPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAcceptanceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAcceptanceDTO>;
        }));
    }

    protected processAcceptPrivacyPolicy(response: HttpResponseBase): Observable<UserAcceptanceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAcceptanceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getProduct(id: number | undefined): Observable<ProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/GetProduct?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDTO>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchProducts(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined, onlyFavourites: boolean | undefined): Observable<PagedResultDTOOfProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/SearchProducts?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (onlyFavourites === null)
            throw new globalThis.Error("The parameter 'onlyFavourites' cannot be null.");
        else if (onlyFavourites !== undefined)
            url_ += "onlyFavourites=" + encodeURIComponent("" + onlyFavourites) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProductDTO>;
        }));
    }

    protected processSearchProducts(response: HttpResponseBase): Observable<PagedResultDTOOfProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProduct(createProductDto: CreateProductDTO): Observable<ProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/CreateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProductDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDTO>;
        }));
    }

    protected processCreateProduct(response: HttpResponseBase): Observable<ProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProduct(updateProductDto: UpdateProductDTO): Observable<ProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/UpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProductDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDTO>;
        }));
    }

    protected processUpdateProduct(response: HttpResponseBase): Observable<ProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Product/DeleteProduct?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrustedSellerProducts(): Observable<PagedResultDTOOfProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/GetTrustedSellerProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrustedSellerProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrustedSellerProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProductDTO>;
        }));
    }

    protected processGetTrustedSellerProducts(response: HttpResponseBase): Observable<PagedResultDTOOfProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadProductImage(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, tempGuid: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Product/UploadProductImage?";
        if (tempGuid === null)
            throw new globalThis.Error("The parameter 'tempGuid' cannot be null.");
        else if (tempGuid !== undefined)
            url_ += "tempGuid=" + encodeURIComponent("" + tempGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new globalThis.Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new globalThis.Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new globalThis.Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProductImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadProductImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecommendedProducts(): Observable<PagedResultDTOOfProductDTO> {
        let url_ = this.baseUrl + "/api/v1/Product/GetRecommendedProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecommendedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecommendedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProductDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProductDTO>;
        }));
    }

    protected processGetRecommendedProducts(response: HttpResponseBase): Observable<PagedResultDTOOfProductDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProductDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateRelistAvailableUntil(productId: number | undefined): Observable<DateTime | null> {
        let url_ = this.baseUrl + "/api/v1/Product/CalculateRelistAvailableUntil?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRelistAvailableUntil(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRelistAvailableUntil(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime | null>;
        }));
    }

    protected processCalculateRelistAvailableUntil(response: HttpResponseBase): Observable<DateTime | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getTemplate(id: number | undefined): Observable<ProductTemplateDTO> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/GetTemplate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTemplateDTO>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<ProductTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTemplates(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfProductTemplateSummaryDTO> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/SearchTemplates?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfProductTemplateSummaryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfProductTemplateSummaryDTO>;
        }));
    }

    protected processSearchTemplates(response: HttpResponseBase): Observable<PagedResultDTOOfProductTemplateSummaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfProductTemplateSummaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTemplate(createDto: CreateProductTemplateDTO): Observable<ProductTemplateDTO> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/CreateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTemplateDTO>;
        }));
    }

    protected processCreateTemplate(response: HttpResponseBase): Observable<ProductTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTemplate(updateDto: UpdateProductTemplateDTO): Observable<ProductTemplateDTO> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/UpdateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTemplateDTO>;
        }));
    }

    protected processUpdateTemplate(response: HttpResponseBase): Observable<ProductTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTemplate(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/DeleteTemplate?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadTemplateImage(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers2[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, tempGuid: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/UploadTemplateImage?";
        if (tempGuid === null)
            throw new globalThis.Error("The parameter 'tempGuid' cannot be null.");
        else if (tempGuid !== undefined)
            url_ += "tempGuid=" + encodeURIComponent("" + tempGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new globalThis.Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new globalThis.Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new globalThis.Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTemplateImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTemplateImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadTemplateImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkPublishConflicts(templateIds: number[]): Observable<ProductConflictDTO[]> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/CheckPublishConflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templateIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPublishConflicts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPublishConflicts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductConflictDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductConflictDTO[]>;
        }));
    }

    protected processCheckPublishConflicts(response: HttpResponseBase): Observable<ProductConflictDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductConflictDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishFromTemplates(publishRequests: PublishProductFromTemplateDTO[]): Observable<ProductDTO[]> {
        let url_ = this.baseUrl + "/api/v1/ProductTemplate/PublishFromTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publishRequests);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishFromTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishFromTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDTO[]>;
        }));
    }

    protected processPublishFromTemplates(response: HttpResponseBase): Observable<ProductDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PushNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    sendPushNotification(model: SendPushNotificationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PushNotification/SendPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPushNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPushNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegistrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    step1(model: RegistrationStepOneDTO): Observable<RegistrationIdDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationIdDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationIdDTO>;
        }));
    }

    protected processStep1(response: HttpResponseBase): Observable<RegistrationIdDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationIdDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestOTP(model: PhoneNumberDTO, registrationId: string | undefined): Observable<OTPResponseDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/RequestOTP?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OTPResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OTPResponseDTO>;
        }));
    }

    protected processRequestOTP(response: HttpResponseBase): Observable<OTPResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OTPResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step2(model: OTPVerificationDTO, registrationId: string | undefined): Observable<PhoneVerificationDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step2?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneVerificationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneVerificationDTO>;
        }));
    }

    protected processStep2(response: HttpResponseBase): Observable<PhoneVerificationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneVerificationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestEmailOTP(model: EmailDTO, registrationId: string | undefined): Observable<OTPResponseDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/RequestEmailOTP?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestEmailOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestEmailOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OTPResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OTPResponseDTO>;
        }));
    }

    protected processRequestEmailOTP(response: HttpResponseBase): Observable<OTPResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OTPResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step3(model: EmailOTPVerificationDTO, registrationId: string | undefined): Observable<EmailDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step3?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailDTO>;
        }));
    }

    protected processStep3(response: HttpResponseBase): Observable<EmailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step4(model: RegistrationStepThreeDTO, registrationId: string | undefined): Observable<RegistrationStepThreeDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step4?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationStepThreeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationStepThreeDTO>;
        }));
    }

    protected processStep4(response: HttpResponseBase): Observable<RegistrationStepThreeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStepThreeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step5(model: RegistrationStepFourDTO, registrationId: string | undefined): Observable<RegistrationStepFourDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step5?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationStepFourDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationStepFourDTO>;
        }));
    }

    protected processStep5(response: HttpResponseBase): Observable<RegistrationStepFourDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStepFourDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step6(model: RegistrationStepFiveDTO, registrationId: string | undefined): Observable<RegistrationStepFiveDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step6?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationStepFiveDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationStepFiveDTO>;
        }));
    }

    protected processStep6(response: HttpResponseBase): Observable<RegistrationStepFiveDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStepFiveDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step7(model: AcceptPrivacyPolicyDTO, registrationId: string | undefined): Observable<AcceptPrivacyPolicyDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step7?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcceptPrivacyPolicyDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcceptPrivacyPolicyDTO>;
        }));
    }

    protected processStep7(response: HttpResponseBase): Observable<AcceptPrivacyPolicyDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptPrivacyPolicyDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    step8(model: UpdateUserInterestedCategoriesDTO, registrationId: string | undefined): Observable<UserIdDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/Step8?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStep8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStep8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserIdDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserIdDTO>;
        }));
    }

    protected processStep8(response: HttpResponseBase): Observable<UserIdDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserIdDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    continueRegistration(model: PhoneNumberDTO): Observable<RegistrationStatusDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/ContinueRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContinueRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContinueRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationStatusDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationStatusDTO>;
        }));
    }

    protected processContinueRegistration(response: HttpResponseBase): Observable<RegistrationStatusDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegistrationStatus(registrationId: string | undefined): Observable<RegistrationStatusDTO> {
        let url_ = this.baseUrl + "/api/v1/Registration/GetRegistrationStatus?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationStatusDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationStatusDTO>;
        }));
    }

    protected processGetRegistrationStatus(response: HttpResponseBase): Observable<RegistrationStatusDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    abandonRegistration(registrationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Registration/AbandonRegistration?";
        if (registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbandonRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbandonRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAbandonRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nearbyUsers(latitude: number | undefined, longitude: number | undefined, radiusInKm: number | undefined): Observable<NearbyUserDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Registration/NearbyUsers?";
        if (latitude === null)
            throw new globalThis.Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new globalThis.Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (radiusInKm === null)
            throw new globalThis.Error("The parameter 'radiusInKm' cannot be null.");
        else if (radiusInKm !== undefined)
            url_ += "radiusInKm=" + encodeURIComponent("" + radiusInKm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNearbyUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNearbyUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NearbyUserDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NearbyUserDTO[]>;
        }));
    }

    protected processNearbyUsers(response: HttpResponseBase): Observable<NearbyUserDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NearbyUserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesOverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getClientSalesOverview(filters: SalesOverviewFilterDTO | undefined, skip: number | undefined, take: number | undefined): Observable<ClientSalesOverviewDTO> {
        let url_ = this.baseUrl + "/api/v1/SalesOverview/GetClientSalesOverview?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientSalesOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientSalesOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSalesOverviewDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSalesOverviewDTO>;
        }));
    }

    protected processGetClientSalesOverview(response: HttpResponseBase): Observable<ClientSalesOverviewDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientSalesOverviewDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SellerProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getMySellerProfiles(): Observable<SellerProfileDTO[]> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/GetMySellerProfiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySellerProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySellerProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerProfileDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerProfileDTO[]>;
        }));
    }

    protected processGetMySellerProfiles(response: HttpResponseBase): Observable<SellerProfileDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellerProfileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSellerProfilesByUserId(userId: string | undefined): Observable<SellerProfileDTO[]> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/GetSellerProfilesByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellerProfilesByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellerProfilesByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerProfileDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerProfileDTO[]>;
        }));
    }

    protected processGetSellerProfilesByUserId(response: HttpResponseBase): Observable<SellerProfileDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellerProfileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSellerProfile(createDto: CreateSellerProfileDTO): Observable<SellerProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/CreateSellerProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSellerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSellerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerProfileDTO>;
        }));
    }

    protected processCreateSellerProfile(response: HttpResponseBase): Observable<SellerProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellerProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSellerProfile(updateDto: UpdateSellerProfileDTO): Observable<SellerProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/UpdateSellerProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSellerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSellerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerProfileDTO>;
        }));
    }

    protected processUpdateSellerProfile(response: HttpResponseBase): Observable<SellerProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellerProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSellerProfile(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/DeleteSellerProfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSellerProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSellerProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSellerProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadSellerProfileImage(contentType: string | undefined, contentDisposition: string | undefined, headers: Headers3[] | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, profileId: number | undefined): Observable<SellerProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/SellerProfile/UploadSellerProfileImage?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new globalThis.Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("ContentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new globalThis.Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new globalThis.Error("The parameter 'headers' cannot be null.");
        else
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSellerProfileImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSellerProfileImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellerProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellerProfileDTO>;
        }));
    }

    protected processUploadSellerProfileImage(response: HttpResponseBase): Observable<SellerProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellerProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    createSubscription(subscription: CreateSubscriptionDTO): Observable<SubscriptionDTO> {
        let url_ = this.baseUrl + "/api/v1/Subscription/CreateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDTO>;
        }));
    }

    protected processCreateSubscription(response: HttpResponseBase): Observable<SubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscription(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Subscription/DeleteSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscription(id: number | undefined): Observable<SubscriptionDTO> {
        let url_ = this.baseUrl + "/api/v1/Subscription/GetSubscription?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDTO>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<SubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAllSubscription(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfSubscriptionDTO> {
        let url_ = this.baseUrl + "/api/v1/Subscription/SearchAllSubscription?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAllSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAllSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfSubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfSubscriptionDTO>;
        }));
    }

    protected processSearchAllSubscription(response: HttpResponseBase): Observable<PagedResultDTOOfSubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfSubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSubscription(subscription: UpdateSubscriptionDTO): Observable<SubscriptionDTO> {
        let url_ = this.baseUrl + "/api/v1/Subscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDTO>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<SubscriptionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUserForSubscription(subscriptionId: number | undefined, filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/Subscription/SearchUserForSubscription?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUserForSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUserForSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUserForSubscription(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrustClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    addTrust(model: AddTrustDTO): Observable<TrustRelationshipDTO> {
        let url_ = this.baseUrl + "/api/v1/Trust/AddTrust";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTrust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTrust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRelationshipDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRelationshipDTO>;
        }));
    }

    protected processAddTrust(response: HttpResponseBase): Observable<TrustRelationshipDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrustRelationshipDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrustedUsers(): Observable<TrustRelationshipDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Trust/GetTrustedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrustedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrustedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRelationshipDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRelationshipDTO[]>;
        }));
    }

    protected processGetTrustedUsers(response: HttpResponseBase): Observable<TrustRelationshipDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustRelationshipDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeTrust(trustedUserId: string | undefined): Observable<TrustRemovalDTO> {
        let url_ = this.baseUrl + "/api/v1/Trust/RemoveTrust?";
        if (trustedUserId === null)
            throw new globalThis.Error("The parameter 'trustedUserId' cannot be null.");
        else if (trustedUserId !== undefined)
            url_ += "trustedUserId=" + encodeURIComponent("" + trustedUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTrust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTrust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRemovalDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRemovalDTO>;
        }));
    }

    protected processRemoveTrust(response: HttpResponseBase): Observable<TrustRemovalDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrustRemovalDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersTrustingMe(): Observable<TrustRelationshipDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Trust/GetUsersTrustingMe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersTrustingMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersTrustingMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRelationshipDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRelationshipDTO[]>;
        }));
    }

    protected processGetUsersTrustingMe(response: HttpResponseBase): Observable<TrustRelationshipDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustRelationshipDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTrustRequest(model: SendTrustRequestDTO): Observable<TrustRequestDTO> {
        let url_ = this.baseUrl + "/api/v1/Trust/SendTrustRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTrustRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTrustRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRequestDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRequestDTO>;
        }));
    }

    protected processSendTrustRequest(response: HttpResponseBase): Observable<TrustRequestDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrustRequestDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveTrustRequest(model: TrustRequestActionDTO): Observable<TrustRequestDTO> {
        let url_ = this.baseUrl + "/api/v1/Trust/ApproveTrustRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTrustRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTrustRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRequestDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRequestDTO>;
        }));
    }

    protected processApproveTrustRequest(response: HttpResponseBase): Observable<TrustRequestDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrustRequestDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectTrustRequest(model: TrustRequestActionDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Trust/RejectTrustRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTrustRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTrustRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectTrustRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingTrustRequests(): Observable<TrustRequestDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Trust/GetPendingTrustRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingTrustRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingTrustRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRequestDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRequestDTO[]>;
        }));
    }

    protected processGetPendingTrustRequests(response: HttpResponseBase): Observable<TrustRequestDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustRequestDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSentTrustRequests(): Observable<TrustRequestDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Trust/GetSentTrustRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSentTrustRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentTrustRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRequestDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRequestDTO[]>;
        }));
    }

    protected processGetSentTrustRequests(response: HttpResponseBase): Observable<TrustRequestDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustRequestDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFavouriteStatus(sellerId: string | undefined, model: UpdateFavouriteDTO): Observable<TrustRelationshipDTO> {
        let url_ = this.baseUrl + "/api/v1/Trust/UpdateFavouriteStatus?";
        if (sellerId === null)
            throw new globalThis.Error("The parameter 'sellerId' cannot be null.");
        else if (sellerId !== undefined)
            url_ += "sellerId=" + encodeURIComponent("" + sellerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFavouriteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFavouriteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRelationshipDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRelationshipDTO>;
        }));
    }

    protected processUpdateFavouriteStatus(response: HttpResponseBase): Observable<TrustRelationshipDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrustRelationshipDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFavouriteSellers(): Observable<TrustRelationshipDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Trust/GetFavouriteSellers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavouriteSellers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavouriteSellers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrustRelationshipDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrustRelationshipDTO[]>;
        }));
    }

    protected processGetFavouriteSellers(response: HttpResponseBase): Observable<TrustRelationshipDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrustRelationshipDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    info(): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/Info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(filters: FilterDTO[] | undefined, clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/SearchUsers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserLanguage(language: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/SetUserLanguage?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    regenerateAccessCode(userId: string | undefined): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/RegenerateAccessCode?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateAccessCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processRegenerateAccessCode(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(model: CreateUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginWithPhone(model: PhoneLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/LoginWithPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginWithPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginWithPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processLoginWithPhone(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPassword(model: SetPasswordDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(model: ForgotPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinimumClientVersion(): Observable<MinimumClientVersionDTO> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/GetMinimumClientVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinimumClientVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinimumClientVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimumClientVersionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimumClientVersionDTO>;
        }));
    }

    protected processGetMinimumClientVersion(response: HttpResponseBase): Observable<MinimumClientVersionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimumClientVersionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDeliveryExecutives(): Observable<UserInfoDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/GetDeliveryExecutives";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryExecutives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryExecutives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO[]>;
        }));
    }

    protected processGetDeliveryExecutives(response: HttpResponseBase): Observable<UserInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canRemoveDeliveryExecutiveRole(userId: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/CanRemoveDeliveryExecutiveRole?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanRemoveDeliveryExecutiveRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanRemoveDeliveryExecutiveRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCanRemoveDeliveryExecutiveRole(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSuggestedContacts(input: SuggestedContactsInputDTO): Observable<UserInfoDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/GetSuggestedContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO[]>;
        }));
    }

    protected processGetSuggestedContacts(response: HttpResponseBase): Observable<UserInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAccount(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v1/UserAccount/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    get(): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(updateProfileDto: UpdateUserProfileDTO): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProfileDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadPicture(file: FileParameter | undefined): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/UploadPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processUploadPicture(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPhoneOTP(updatePhoneDto: UpdatePhoneNumberDTO): Observable<PhoneUpdateResponseDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/RequestPhoneOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePhoneDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPhoneOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPhoneOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneUpdateResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneUpdateResponseDTO>;
        }));
    }

    protected processRequestPhoneOTP(response: HttpResponseBase): Observable<PhoneUpdateResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneUpdateResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyPhone(verifyPhoneDto: VerifyPhoneUpdateDTO): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/VerifyPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verifyPhoneDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processVerifyPhone(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(userId: string): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetById/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByClientId(): Observable<UserProfileDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetByClientId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO[]>;
        }));
    }

    protected processGetByClientId(response: HttpResponseBase): Observable<UserProfileDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyInterestedCategories(): Observable<CategoryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetMyInterestedCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInterestedCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInterestedCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO[]>;
        }));
    }

    protected processGetMyInterestedCategories(response: HttpResponseBase): Observable<CategoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addInterestedCategory(dto: ModifyUserInterestedCategoryDTO): Observable<CategoryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/AddInterestedCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInterestedCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInterestedCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO[]>;
        }));
    }

    protected processAddInterestedCategory(response: HttpResponseBase): Observable<CategoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInterestedCategory(categoryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/DeleteInterestedCategory?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInterestedCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInterestedCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInterestedCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInterestedCategory(categoryId: number | undefined, dto: ModifyUserInterestedCategoryDTO): Observable<CategoryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/UpdateInterestedCategory?";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInterestedCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInterestedCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDTO[]>;
        }));
    }

    protected processUpdateInterestedCategory(response: HttpResponseBase): Observable<CategoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestEmailOTP(emailDto: EmailDTO): Observable<OTPResponseDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/RequestEmailOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestEmailOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestEmailOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OTPResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OTPResponseDTO>;
        }));
    }

    protected processRequestEmailOTP(response: HttpResponseBase): Observable<OTPResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OTPResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyEmailOTP(verifyEmailDto: EmailOTPVerificationDTO): Observable<UserProfileDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/VerifyEmailOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verifyEmailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmailOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmailOTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDTO>;
        }));
    }

    protected processVerifyEmailOTP(response: HttpResponseBase): Observable<UserProfileDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySubscription(): Observable<UserSubscriptionDetailsDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetMySubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSubscriptionDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSubscriptionDetailsDTO>;
        }));
    }

    protected processGetMySubscription(response: HttpResponseBase): Observable<UserSubscriptionDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSubscriptionDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyInvoices(skip: number | undefined, take: number | undefined): Observable<UserInvoiceListDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetMyInvoices?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInvoiceListDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInvoiceListDTO[]>;
        }));
    }

    protected processGetMyInvoices(response: HttpResponseBase): Observable<UserInvoiceListDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInvoiceListDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyInvoiceDetails(invoiceId: number | undefined): Observable<InvoiceDTO> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetMyInvoiceDetails?";
        if (invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInvoiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInvoiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDTO>;
        }));
    }

    protected processGetMyInvoiceDetails(response: HttpResponseBase): Observable<InvoiceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyPaymentHistory(skip: number | undefined, take: number | undefined): Observable<UserPaymentHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserProfile/GetMyPaymentHistory?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPaymentHistoryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPaymentHistoryDTO[]>;
        }));
    }

    protected processGetMyPaymentHistory(response: HttpResponseBase): Observable<UserPaymentHistoryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPaymentHistoryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:7225";
    }

    getVersion(): Observable<OfF__AnonymousType7OfStringAndStringAndString> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfF__AnonymousType7OfStringAndStringAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfF__AnonymousType7OfStringAndStringAndString>;
        }));
    }

    protected processGetVersion(response: HttpResponseBase): Observable<OfF__AnonymousType7OfStringAndStringAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfF__AnonymousType7OfStringAndStringAndString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserTokenDTO implements IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn!: number;
    expires_in!: number;
    expires?: string | undefined;

    constructor(data?: IUserTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.username = _data["username"];
            this.clientId = _data["clientId"];
            this.refresh_token = _data["refresh_token"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            this.expires_in = _data["expires_in"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): UserTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["username"] = this.username;
        data["clientId"] = this.clientId;
        data["refresh_token"] = this.refresh_token;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        data["expires_in"] = this.expires_in;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn: number;
    expires_in: number;
    expires?: string | undefined;
}

export class UserLoginDTO implements IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.grant_Type = _data["grant_Type"];
            this.client_Id = _data["client_Id"];
            this.client_Secret = _data["client_Secret"];
            this.refresh_Token = _data["refresh_Token"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["grant_Type"] = this.grant_Type;
        data["client_Id"] = this.client_Id;
        data["client_Secret"] = this.client_Secret;
        data["refresh_Token"] = this.refresh_Token;
        return data;
    }
}

export interface IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
}

export class CartDTO implements ICartDTO {
    id!: number;
    userId?: string | undefined;
    items?: CartItemDTO[] | undefined;
    totalAmount!: number;
    totalItems!: number;

    constructor(data?: ICartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CartItemDTO.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): CartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalAmount"] = this.totalAmount;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ICartDTO {
    id: number;
    userId?: string | undefined;
    items?: CartItemDTO[] | undefined;
    totalAmount: number;
    totalItems: number;
}

export class CartItemDTO implements ICartItemDTO {
    id!: number;
    cartId!: number;
    productId!: number;
    productName?: string | undefined;
    productImage?: string | undefined;
    unitPrice!: number;
    totalPrice!: number;
    quantity!: number;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    sellerProfileName?: string | undefined;
    addedOn!: DateTime;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;

    constructor(data?: ICartItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cartId = _data["cartId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productImage = _data["productImage"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.quantity = _data["quantity"];
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.sellerProfileName = _data["sellerProfileName"];
            this.addedOn = _data["addedOn"] ? DateTime.fromISO(_data["addedOn"].toString()) : undefined as any;
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
        }
    }

    static fromJS(data: any): CartItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cartId"] = this.cartId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productImage"] = this.productImage;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["quantity"] = this.quantity;
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        data["sellerProfileId"] = this.sellerProfileId;
        data["sellerProfileName"] = this.sellerProfileName;
        data["addedOn"] = this.addedOn ? this.addedOn.toString() : undefined as any;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        return data;
    }
}

export interface ICartItemDTO {
    id: number;
    cartId: number;
    productId: number;
    productName?: string | undefined;
    productImage?: string | undefined;
    unitPrice: number;
    totalPrice: number;
    quantity: number;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    sellerProfileName?: string | undefined;
    addedOn: DateTime;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
}

export enum UnitType {
    Gram = 1,
    Kilogram = 2,
    Pound = 3,
    Ounce = 4,
    Milliliter = 5,
    Liter = 6,
    FluidOunce = 7,
    Cup = 8,
    Pint = 9,
    Quart = 10,
    Gallon = 11,
    Millimeter = 12,
    Centimeter = 13,
    Meter = 14,
    Inch = 15,
    Foot = 16,
    Yard = 17,
    Piece = 18,
    Pair = 19,
    Dozen = 20,
    Pack = 21,
    Box = 22,
    Bottle = 23,
    Bag = 24,
    SquareCentimeter = 25,
    SquareMeter = 26,
    SquareFoot = 27,
    SquareInch = 28,
}

export class AddToCartDTO implements IAddToCartDTO {
    productId!: number;
    quantity!: number;

    constructor(data?: IAddToCartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AddToCartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddToCartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IAddToCartDTO {
    productId: number;
    quantity: number;
}

export class UpdateCartItemDTO implements IUpdateCartItemDTO {
    cartItemId!: number;
    quantity!: number;

    constructor(data?: IUpdateCartItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartItemId = _data["cartItemId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): UpdateCartItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCartItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItemId"] = this.cartItemId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IUpdateCartItemDTO {
    cartItemId: number;
    quantity: number;
}

export class RemoveFromCartDTO implements IRemoveFromCartDTO {
    cartItemId!: number;

    constructor(data?: IRemoveFromCartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartItemId = _data["cartItemId"];
        }
    }

    static fromJS(data: any): RemoveFromCartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFromCartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItemId"] = this.cartItemId;
        return data;
    }
}

export interface IRemoveFromCartDTO {
    cartItemId: number;
}

export class OrderDTO implements IOrderDTO {
    id!: number;
    orderNumber?: string | undefined;
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    orderDate!: DateTime;
    totalAmount!: number;
    status!: OrderStatus;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    deliveryInstructions?: string | undefined;
    cancellationReason?: string | undefined;
    items?: OrderItemDTO[] | undefined;
    statusHistory?: OrderStatusHistoryDTO[] | undefined;

    constructor(data?: IOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.buyerId = _data["buyerId"];
            this.buyerName = _data["buyerName"];
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.orderDate = _data["orderDate"] ? DateTime.fromISO(_data["orderDate"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.contactNumber = _data["contactNumber"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.cancellationReason = _data["cancellationReason"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["statusHistory"])) {
                this.statusHistory = [] as any;
                for (let item of _data["statusHistory"])
                    this.statusHistory!.push(OrderStatusHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["buyerId"] = this.buyerId;
        data["buyerName"] = this.buyerName;
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        data["sellerProfileId"] = this.sellerProfileId;
        data["orderDate"] = this.orderDate ? this.orderDate.toString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["deliveryAddress"] = this.deliveryAddress;
        data["contactNumber"] = this.contactNumber;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["cancellationReason"] = this.cancellationReason;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statusHistory)) {
            data["statusHistory"] = [];
            for (let item of this.statusHistory)
                data["statusHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderDTO {
    id: number;
    orderNumber?: string | undefined;
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    orderDate: DateTime;
    totalAmount: number;
    status: OrderStatus;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    deliveryInstructions?: string | undefined;
    cancellationReason?: string | undefined;
    items?: OrderItemDTO[] | undefined;
    statusHistory?: OrderStatusHistoryDTO[] | undefined;
}

export enum OrderStatus {
    Pending = 0,
    Processing = 1,
    OutForDelivery = 2,
    Delivered = 3,
    Cancelled = 4,
}

export class OrderItemDTO implements IOrderItemDTO {
    id!: number;
    orderId!: number;
    productId!: number;
    productName?: string | undefined;
    productImage?: string | undefined;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    status!: OrderStatus;

    constructor(data?: IOrderItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productImage = _data["productImage"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OrderItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productImage"] = this.productImage;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["status"] = this.status;
        return data;
    }
}

export interface IOrderItemDTO {
    id: number;
    orderId: number;
    productId: number;
    productName?: string | undefined;
    productImage?: string | undefined;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    status: OrderStatus;
}

export class OrderStatusHistoryDTO implements IOrderStatusHistoryDTO {
    id!: number;
    orderId!: number;
    status!: OrderStatus;
    note?: string | undefined;
    changedById?: string | undefined;
    changedByName?: string | undefined;
    changedOn!: DateTime;

    constructor(data?: IOrderStatusHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.changedById = _data["changedById"];
            this.changedByName = _data["changedByName"];
            this.changedOn = _data["changedOn"] ? DateTime.fromISO(_data["changedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OrderStatusHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        data["note"] = this.note;
        data["changedById"] = this.changedById;
        data["changedByName"] = this.changedByName;
        data["changedOn"] = this.changedOn ? this.changedOn.toString() : undefined as any;
        return data;
    }
}

export interface IOrderStatusHistoryDTO {
    id: number;
    orderId: number;
    status: OrderStatus;
    note?: string | undefined;
    changedById?: string | undefined;
    changedByName?: string | undefined;
    changedOn: DateTime;
}

export class CheckoutDTO implements ICheckoutDTO {
    deliveryAddress!: string;
    contactNumber!: string;
    deliveryInstructions?: string | undefined;

    constructor(data?: ICheckoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAddress = _data["deliveryAddress"];
            this.contactNumber = _data["contactNumber"];
            this.deliveryInstructions = _data["deliveryInstructions"];
        }
    }

    static fromJS(data: any): CheckoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAddress"] = this.deliveryAddress;
        data["contactNumber"] = this.contactNumber;
        data["deliveryInstructions"] = this.deliveryInstructions;
        return data;
    }
}

export interface ICheckoutDTO {
    deliveryAddress: string;
    contactNumber: string;
    deliveryInstructions?: string | undefined;
}

export class CategoryDTO implements ICategoryDTO {
    categoryId!: number;
    name?: string | undefined;

    constructor(data?: ICategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategoryDTO {
    categoryId: number;
    name?: string | undefined;
}

export class CreateCategoryDTO implements ICreateCategoryDTO {
    name!: string;

    constructor(data?: ICreateCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCategoryDTO {
    name: string;
}

export class UpdateCategoryDTO implements IUpdateCategoryDTO {
    categoryId!: number;
    name?: string | undefined;

    constructor(data?: IUpdateCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateCategoryDTO {
    categoryId: number;
    name?: string | undefined;
}

export class PagedResultDTOOfCategoryDTO implements IPagedResultDTOOfCategoryDTO {
    items?: CategoryDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CategoryDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfCategoryDTO {
    items?: CategoryDTO[] | undefined;
    totalNumberOfItems: number;
}

export class FilterDTO implements IFilterDTO {
    isComplex!: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplex = _data["isComplex"];
            this.condition = _data["condition"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            if (Array.isArray(_data["predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["predicates"])
                    this.predicates!.push(FilterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplex"] = this.isComplex;
        data["condition"] = this.condition;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        if (Array.isArray(this.predicates)) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    isComplex: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;
}

export enum FilterCondition {
    And = 0,
    Or = 1,
}

export enum FilterOperator {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    LessThan = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
    Any = 11,
    None = 12,
    Empty = 13,
    NotEmpty = 14,
    DoesNotStartWith = 15,
    DoesNotEndWith = 16,
    DoesNotContain = 17,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class ClientDTO implements IClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive!: boolean;

    constructor(data?: IClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive: boolean;
}

export class CreateClientDTO implements ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name!: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;

    constructor(data?: ICreateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): CreateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        return data;
    }
}

export interface ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
}

export class PagedResultDTOOfClientDTO implements IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateClientDTO implements IUpdateClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean | undefined;
}

export class SellerOverviewDTO implements ISellerOverviewDTO {
    totalSales!: number;
    pendingOrders!: number;
    completedOrders!: number;
    activeListings!: number;

    constructor(data?: ISellerOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.pendingOrders = _data["pendingOrders"];
            this.completedOrders = _data["completedOrders"];
            this.activeListings = _data["activeListings"];
        }
    }

    static fromJS(data: any): SellerOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SellerOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["pendingOrders"] = this.pendingOrders;
        data["completedOrders"] = this.completedOrders;
        data["activeListings"] = this.activeListings;
        return data;
    }
}

export interface ISellerOverviewDTO {
    totalSales: number;
    pendingOrders: number;
    completedOrders: number;
    activeListings: number;
}

export class WeeklyPerformanceDTO implements IWeeklyPerformanceDTO {
    salesByDay!: DailySalesDTO[];
    totalBuyers!: number;

    constructor(data?: IWeeklyPerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.salesByDay = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesByDay"])) {
                this.salesByDay = [] as any;
                for (let item of _data["salesByDay"])
                    this.salesByDay!.push(DailySalesDTO.fromJS(item));
            }
            this.totalBuyers = _data["totalBuyers"];
        }
    }

    static fromJS(data: any): WeeklyPerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyPerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesByDay)) {
            data["salesByDay"] = [];
            for (let item of this.salesByDay)
                data["salesByDay"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalBuyers"] = this.totalBuyers;
        return data;
    }
}

export interface IWeeklyPerformanceDTO {
    salesByDay: DailySalesDTO[];
    totalBuyers: number;
}

export class DailySalesDTO implements IDailySalesDTO {
    day?: string | undefined;
    sales!: number;

    constructor(data?: IDailySalesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.sales = _data["sales"];
        }
    }

    static fromJS(data: any): DailySalesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DailySalesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["sales"] = this.sales;
        return data;
    }
}

export interface IDailySalesDTO {
    day?: string | undefined;
    sales: number;
}

export class TopProductDTO implements ITopProductDTO {
    productId!: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    unitsSold!: number;
    totalRevenue!: number;
    unitOfMeasure?: string | undefined;
    unitValue?: number | undefined;
    unitType?: number | undefined;

    constructor(data?: ITopProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.unitsSold = _data["unitsSold"];
            this.totalRevenue = _data["totalRevenue"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
        }
    }

    static fromJS(data: any): TopProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TopProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["unitsSold"] = this.unitsSold;
        data["totalRevenue"] = this.totalRevenue;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        return data;
    }
}

export interface ITopProductDTO {
    productId: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    unitsSold: number;
    totalRevenue: number;
    unitOfMeasure?: string | undefined;
    unitValue?: number | undefined;
    unitType?: number | undefined;
}

export class AlertDTO implements IAlertDTO {
    productId!: number;
    productName?: string | undefined;
    currentStock!: number;
    daysToExpire?: number | undefined;
    alertType?: string | undefined;
    severity?: string | undefined;

    constructor(data?: IAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.currentStock = _data["currentStock"];
            this.daysToExpire = _data["daysToExpire"];
            this.alertType = _data["alertType"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["currentStock"] = this.currentStock;
        data["daysToExpire"] = this.daysToExpire;
        data["alertType"] = this.alertType;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAlertDTO {
    productId: number;
    productName?: string | undefined;
    currentStock: number;
    daysToExpire?: number | undefined;
    alertType?: string | undefined;
    severity?: string | undefined;
}

export class InventoryPerformanceDTO implements IInventoryPerformanceDTO {
    totalOriginalQuantity!: number;
    totalSold!: number;
    remainingStock!: number;

    constructor(data?: IInventoryPerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOriginalQuantity = _data["totalOriginalQuantity"];
            this.totalSold = _data["totalSold"];
            this.remainingStock = _data["remainingStock"];
        }
    }

    static fromJS(data: any): InventoryPerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryPerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOriginalQuantity"] = this.totalOriginalQuantity;
        data["totalSold"] = this.totalSold;
        data["remainingStock"] = this.remainingStock;
        return data;
    }
}

export interface IInventoryPerformanceDTO {
    totalOriginalQuantity: number;
    totalSold: number;
    remainingStock: number;
}

export class DeliveryPerformanceDTO implements IDeliveryPerformanceDTO {
    totalOrderItems!: number;
    deliveredItems!: number;
    deliveryPercentage!: number;

    constructor(data?: IDeliveryPerformanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOrderItems = _data["totalOrderItems"];
            this.deliveredItems = _data["deliveredItems"];
            this.deliveryPercentage = _data["deliveryPercentage"];
        }
    }

    static fromJS(data: any): DeliveryPerformanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryPerformanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOrderItems"] = this.totalOrderItems;
        data["deliveredItems"] = this.deliveredItems;
        data["deliveryPercentage"] = this.deliveryPercentage;
        return data;
    }
}

export interface IDeliveryPerformanceDTO {
    totalOrderItems: number;
    deliveredItems: number;
    deliveryPercentage: number;
}

export class DeliveryPlanDTO implements IDeliveryPlanDTO {
    id!: number;
    name?: string | undefined;
    status!: DeliveryStatus;
    comments?: string | undefined;
    deliveryDate!: DateTime;
    assignedToId?: string | undefined;
    assignedToName?: string | undefined;
    details!: DeliveryPlanDetailDTO[];
    createdOn!: DateTime;
    modifiedOn!: DateTime;

    constructor(data?: IDeliveryPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.details = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.comments = _data["comments"];
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : undefined as any;
            this.assignedToId = _data["assignedToId"];
            this.assignedToName = _data["assignedToName"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DeliveryPlanDetailDTO.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DeliveryPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["comments"] = this.comments;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : undefined as any;
        data["assignedToId"] = this.assignedToId;
        data["assignedToName"] = this.assignedToName;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IDeliveryPlanDTO {
    id: number;
    name?: string | undefined;
    status: DeliveryStatus;
    comments?: string | undefined;
    deliveryDate: DateTime;
    assignedToId?: string | undefined;
    assignedToName?: string | undefined;
    details: DeliveryPlanDetailDTO[];
    createdOn: DateTime;
    modifiedOn: DateTime;
}

export enum DeliveryStatus {
    Draft = 0,
    OutForDelivery = 1,
    DeliveryInProgress = 2,
    Delivered = 3,
    Cancelled = 4,
}

export class DeliveryPlanDetailDTO implements IDeliveryPlanDetailDTO {
    id!: number;
    orderId!: number;
    orderNumber?: string | undefined;
    comments?: string | undefined;
    orderAmount!: number;
    buyerName?: string | undefined;
    orderStatus!: OrderStatus;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    distance?: number | undefined;
    items!: OrderItemDTO[];

    constructor(data?: IDeliveryPlanDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.orderNumber = _data["orderNumber"];
            this.comments = _data["comments"];
            this.orderAmount = _data["orderAmount"];
            this.buyerName = _data["buyerName"];
            this.orderStatus = _data["orderStatus"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.contactNumber = _data["contactNumber"];
            this.distance = _data["distance"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryPlanDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryPlanDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["orderNumber"] = this.orderNumber;
        data["comments"] = this.comments;
        data["orderAmount"] = this.orderAmount;
        data["buyerName"] = this.buyerName;
        data["orderStatus"] = this.orderStatus;
        data["deliveryAddress"] = this.deliveryAddress;
        data["contactNumber"] = this.contactNumber;
        data["distance"] = this.distance;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeliveryPlanDetailDTO {
    id: number;
    orderId: number;
    orderNumber?: string | undefined;
    comments?: string | undefined;
    orderAmount: number;
    buyerName?: string | undefined;
    orderStatus: OrderStatus;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    distance?: number | undefined;
    items: OrderItemDTO[];
}

export class CreateDeliveryPlanDTO implements ICreateDeliveryPlanDTO {
    name!: string;
    deliveryDate?: DateTime | undefined;
    assignedToId?: string | undefined;
    comments?: string | undefined;
    orderIds?: number[] | undefined;

    constructor(data?: ICreateDeliveryPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : undefined as any;
            this.assignedToId = _data["assignedToId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeliveryPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : undefined as any;
        data["assignedToId"] = this.assignedToId;
        data["comments"] = this.comments;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        return data;
    }
}

export interface ICreateDeliveryPlanDTO {
    name: string;
    deliveryDate?: DateTime | undefined;
    assignedToId?: string | undefined;
    comments?: string | undefined;
    orderIds?: number[] | undefined;
}

export class UpdateDeliveryStatusDTO implements IUpdateDeliveryStatusDTO {
    name?: string | undefined;
    deliveryDate?: DateTime | undefined;
    assignedToId?: string | undefined;
    comments?: string | undefined;
    orderIds?: number[] | undefined;
    status?: DeliveryStatus | undefined;
    orderComments?: string | undefined;

    constructor(data?: IUpdateDeliveryStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.deliveryDate = _data["deliveryDate"] ? DateTime.fromISO(_data["deliveryDate"].toString()) : undefined as any;
            this.assignedToId = _data["assignedToId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            this.status = _data["status"];
            this.orderComments = _data["orderComments"];
        }
    }

    static fromJS(data: any): UpdateDeliveryStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeliveryStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toString() : undefined as any;
        data["assignedToId"] = this.assignedToId;
        data["comments"] = this.comments;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["status"] = this.status;
        data["orderComments"] = this.orderComments;
        return data;
    }
}

export interface IUpdateDeliveryStatusDTO {
    name?: string | undefined;
    deliveryDate?: DateTime | undefined;
    assignedToId?: string | undefined;
    comments?: string | undefined;
    orderIds?: number[] | undefined;
    status?: DeliveryStatus | undefined;
    orderComments?: string | undefined;
}

export class PagedResultDTOOfDeliveryPlanDTO implements IPagedResultDTOOfDeliveryPlanDTO {
    items?: DeliveryPlanDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfDeliveryPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeliveryPlanDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfDeliveryPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfDeliveryPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfDeliveryPlanDTO {
    items?: DeliveryPlanDTO[] | undefined;
    totalNumberOfItems: number;
}

export class RegisterDeviceInfoDTO implements IRegisterDeviceInfoDTO {
    deviceIdentifier!: string;
    devicePlatform!: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    language?: string | undefined;

    constructor(data?: IRegisterDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.devicePlatform = _data["devicePlatform"];
            this.fcmToken = _data["fcmToken"];
            this.userId = _data["userId"];
            this.appVersion = _data["appVersion"];
            this.deviceVersion = _data["deviceVersion"];
            this.deviceModel = _data["deviceModel"];
            this.deviceName = _data["deviceName"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): RegisterDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["devicePlatform"] = this.devicePlatform;
        data["fcmToken"] = this.fcmToken;
        data["userId"] = this.userId;
        data["appVersion"] = this.appVersion;
        data["deviceVersion"] = this.deviceVersion;
        data["deviceModel"] = this.deviceModel;
        data["deviceName"] = this.deviceName;
        data["language"] = this.language;
        return data;
    }
}

export interface IRegisterDeviceInfoDTO {
    deviceIdentifier: string;
    devicePlatform: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    language?: string | undefined;
}

export enum MobilePlatform {
    Android = 0,
    IOS = 1,
}

export class UnregisterDeviceInfoDTO implements IUnregisterDeviceInfoDTO {
    deviceIdentifier!: string;
    fcmToken?: string | undefined;

    constructor(data?: IUnregisterDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): UnregisterDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnregisterDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["fcmToken"] = this.fcmToken;
        return data;
    }
}

export interface IUnregisterDeviceInfoDTO {
    deviceIdentifier: string;
    fcmToken?: string | undefined;
}

export class UpdateDevicePreferencesDTO implements IUpdateDevicePreferencesDTO {
    deviceIdentifier!: string;

    constructor(data?: IUpdateDevicePreferencesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
        }
    }

    static fromJS(data: any): UpdateDevicePreferencesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDevicePreferencesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        return data;
    }
}

export interface IUpdateDevicePreferencesDTO {
    deviceIdentifier: string;
}

export class InAppNotificationDTO implements IInAppNotificationDTO {
    id!: number;
    type!: NotificationType;
    title!: string;
    message!: string;
    actionData?: string | undefined;
    isRead!: boolean;
    createdOn!: DateTime;
    readAt?: DateTime | undefined;

    constructor(data?: IInAppNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.actionData = _data["actionData"];
            this.isRead = _data["isRead"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.readAt = _data["readAt"] ? DateTime.fromISO(_data["readAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InAppNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InAppNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["message"] = this.message;
        data["actionData"] = this.actionData;
        data["isRead"] = this.isRead;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["readAt"] = this.readAt ? this.readAt.toString() : undefined as any;
        return data;
    }
}

export interface IInAppNotificationDTO {
    id: number;
    type: NotificationType;
    title: string;
    message: string;
    actionData?: string | undefined;
    isRead: boolean;
    createdOn: DateTime;
    readAt?: DateTime | undefined;
}

export enum NotificationType {
    NewProductFromTrustedSeller = 1,
    OrderStatusChanged = 2,
    NewOrderReceived = 3,
    NewTrustConnection = 4,
    TrustRequestReceived = 5,
    TrustRequestApproved = 6,
    ProductExpiringSoon = 7,
    InvoiceGenerated = 8,
}

export class InvoiceOverviewDTO implements IInvoiceOverviewDTO {
    totalInvoices!: number;
    pendingPayments!: number;
    paidInvoices!: number;
    overdueInvoices!: number;
    invoices!: InvoiceDTO[];
    totalCount!: number;

    constructor(data?: IInvoiceOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.invoices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInvoices = _data["totalInvoices"];
            this.pendingPayments = _data["pendingPayments"];
            this.paidInvoices = _data["paidInvoices"];
            this.overdueInvoices = _data["overdueInvoices"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceDTO.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInvoices"] = this.totalInvoices;
        data["pendingPayments"] = this.pendingPayments;
        data["paidInvoices"] = this.paidInvoices;
        data["overdueInvoices"] = this.overdueInvoices;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IInvoiceOverviewDTO {
    totalInvoices: number;
    pendingPayments: number;
    paidInvoices: number;
    overdueInvoices: number;
    invoices: InvoiceDTO[];
    totalCount: number;
}

export class InvoiceDTO implements IInvoiceDTO {
    id!: number;
    invoiceNumber!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    userSubscriptionId!: number;
    subscriptionPlanName?: string | undefined;
    invoiceDate!: DateTime;
    billingPeriodStart!: DateTime;
    billingPeriodEnd!: DateTime;
    totalAmount!: number;
    status!: InvoiceStatus;
    dueDate?: DateTime | undefined;
    paymentDate?: DateTime | undefined;
    paymentMethod?: PaymentMethod | undefined;
    transactionReference?: string | undefined;
    paymentNotes?: string | undefined;
    invoiceLines?: InvoiceLineDTO[] | undefined;
    createdOn!: DateTime;

    constructor(data?: IInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSubscriptionId = _data["userSubscriptionId"];
            this.subscriptionPlanName = _data["subscriptionPlanName"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : undefined as any;
            this.billingPeriodStart = _data["billingPeriodStart"] ? DateTime.fromISO(_data["billingPeriodStart"].toString()) : undefined as any;
            this.billingPeriodEnd = _data["billingPeriodEnd"] ? DateTime.fromISO(_data["billingPeriodEnd"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : undefined as any;
            this.paymentDate = _data["paymentDate"] ? DateTime.fromISO(_data["paymentDate"].toString()) : undefined as any;
            this.paymentMethod = _data["paymentMethod"];
            this.transactionReference = _data["transactionReference"];
            this.paymentNotes = _data["paymentNotes"];
            if (Array.isArray(_data["invoiceLines"])) {
                this.invoiceLines = [] as any;
                for (let item of _data["invoiceLines"])
                    this.invoiceLines!.push(InvoiceLineDTO.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSubscriptionId"] = this.userSubscriptionId;
        data["subscriptionPlanName"] = this.subscriptionPlanName;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : undefined as any;
        data["billingPeriodStart"] = this.billingPeriodStart ? this.billingPeriodStart.toString() : undefined as any;
        data["billingPeriodEnd"] = this.billingPeriodEnd ? this.billingPeriodEnd.toString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : undefined as any;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toString() : undefined as any;
        data["paymentMethod"] = this.paymentMethod;
        data["transactionReference"] = this.transactionReference;
        data["paymentNotes"] = this.paymentNotes;
        if (Array.isArray(this.invoiceLines)) {
            data["invoiceLines"] = [];
            for (let item of this.invoiceLines)
                data["invoiceLines"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        return data;
    }
}

export interface IInvoiceDTO {
    id: number;
    invoiceNumber: string;
    userId?: string | undefined;
    userName?: string | undefined;
    userSubscriptionId: number;
    subscriptionPlanName?: string | undefined;
    invoiceDate: DateTime;
    billingPeriodStart: DateTime;
    billingPeriodEnd: DateTime;
    totalAmount: number;
    status: InvoiceStatus;
    dueDate?: DateTime | undefined;
    paymentDate?: DateTime | undefined;
    paymentMethod?: PaymentMethod | undefined;
    transactionReference?: string | undefined;
    paymentNotes?: string | undefined;
    invoiceLines?: InvoiceLineDTO[] | undefined;
    createdOn: DateTime;
}

export enum InvoiceStatus {
    Draft = 0,
    Issued = 1,
    Paid = 2,
    Cancelled = 3,
    Overdue = 4,
}

export enum PaymentMethod {
    BankTransfer = 0,
    UPI = 1,
    Cash = 2,
    ManualAdjustment = 3,
}

export class InvoiceLineDTO implements IInvoiceLineDTO {
    id!: number;
    invoiceId!: number;
    description!: string;
    amount!: number;
    quantity!: number;

    constructor(data?: IInvoiceLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InvoiceLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IInvoiceLineDTO {
    id: number;
    invoiceId: number;
    description: string;
    amount: number;
    quantity: number;
}

export class InvoiceFilterDTO implements IInvoiceFilterDTO {
    status?: InvoiceStatus | undefined;
    userId?: string | undefined;
    subscriptionId?: number | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    overdueOnly?: boolean | undefined;

    constructor(data?: IInvoiceFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.subscriptionId = _data["subscriptionId"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : undefined as any;
            this.overdueOnly = _data["overdueOnly"];
        }
    }

    static fromJS(data: any): InvoiceFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["subscriptionId"] = this.subscriptionId;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toString() : undefined as any;
        data["overdueOnly"] = this.overdueOnly;
        return data;
    }
}

export interface IInvoiceFilterDTO {
    status?: InvoiceStatus | undefined;
    userId?: string | undefined;
    subscriptionId?: number | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    overdueOnly?: boolean | undefined;
}

export class RecordPaymentDTO implements IRecordPaymentDTO {
    paymentAmount!: number;
    paymentDate!: DateTime;
    paymentMethod!: PaymentMethod;
    transactionReference?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IRecordPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAmount = _data["paymentAmount"];
            this.paymentDate = _data["paymentDate"] ? DateTime.fromISO(_data["paymentDate"].toString()) : undefined as any;
            this.paymentMethod = _data["paymentMethod"];
            this.transactionReference = _data["transactionReference"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RecordPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toString() : undefined as any;
        data["paymentMethod"] = this.paymentMethod;
        data["transactionReference"] = this.transactionReference;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRecordPaymentDTO {
    paymentAmount: number;
    paymentDate: DateTime;
    paymentMethod: PaymentMethod;
    transactionReference?: string | undefined;
    notes?: string | undefined;
}

export class NearbyUserDTO implements INearbyUserDTO {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    displayLocation?: string | undefined;
    distance!: number;
    isTrusted!: boolean;
    photoUrl?: string | undefined;

    constructor(data?: INearbyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.subLocality = _data["subLocality"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.displayLocation = _data["displayLocation"];
            this.distance = _data["distance"];
            this.isTrusted = _data["isTrusted"];
            this.photoUrl = _data["photoUrl"];
        }
    }

    static fromJS(data: any): NearbyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NearbyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["subLocality"] = this.subLocality;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["displayLocation"] = this.displayLocation;
        data["distance"] = this.distance;
        data["isTrusted"] = this.isTrusted;
        data["photoUrl"] = this.photoUrl;
        return data;
    }
}

export interface INearbyUserDTO {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    displayLocation?: string | undefined;
    distance: number;
    isTrusted: boolean;
    photoUrl?: string | undefined;
}

export class NearbyUsersRequestDTO implements INearbyUsersRequestDTO {
    latitude!: number;
    longitude!: number;
    radiusInKm!: number;

    constructor(data?: INearbyUsersRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radiusInKm = _data["radiusInKm"];
        }
    }

    static fromJS(data: any): NearbyUsersRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NearbyUsersRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radiusInKm"] = this.radiusInKm;
        return data;
    }
}

export interface INearbyUsersRequestDTO {
    latitude: number;
    longitude: number;
    radiusInKm: number;
}

export class PagedResultDTOOfNearbyUserDTO implements IPagedResultDTOOfNearbyUserDTO {
    items?: NearbyUserDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfNearbyUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NearbyUserDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfNearbyUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfNearbyUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfNearbyUserDTO {
    items?: NearbyUserDTO[] | undefined;
    totalNumberOfItems: number;
}

export abstract class BaseOrderSummaryDTO implements IBaseOrderSummaryDTO {
    id!: number;
    orderNumber?: string | undefined;
    orderDate!: DateTime;
    totalAmount!: number;
    status!: OrderStatus;
    itemCount!: number;
    items!: OrderItemDTO[];

    constructor(data?: IBaseOrderSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? DateTime.fromISO(_data["orderDate"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.itemCount = _data["itemCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseOrderSummaryDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseOrderSummaryDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["itemCount"] = this.itemCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBaseOrderSummaryDTO {
    id: number;
    orderNumber?: string | undefined;
    orderDate: DateTime;
    totalAmount: number;
    status: OrderStatus;
    itemCount: number;
    items: OrderItemDTO[];
}

export class BuyerOrderSummaryDTO extends BaseOrderSummaryDTO implements IBuyerOrderSummaryDTO {
    sellerId?: string | undefined;
    sellerName?: string | undefined;

    constructor(data?: IBuyerOrderSummaryDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
        }
    }

    static override fromJS(data: any): BuyerOrderSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuyerOrderSummaryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        super.toJSON(data);
        return data;
    }
}

export interface IBuyerOrderSummaryDTO extends IBaseOrderSummaryDTO {
    sellerId?: string | undefined;
    sellerName?: string | undefined;
}

export class SellerOrderSummaryDTO extends BaseOrderSummaryDTO implements ISellerOrderSummaryDTO {
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    deliveryInstructions?: string | undefined;
    sellerProfileId?: string | undefined;
    sellerProfileName?: string | undefined;

    constructor(data?: ISellerOrderSummaryDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.buyerId = _data["buyerId"];
            this.buyerName = _data["buyerName"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.contactNumber = _data["contactNumber"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.sellerProfileName = _data["sellerProfileName"];
        }
    }

    static override fromJS(data: any): SellerOrderSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SellerOrderSummaryDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyerId"] = this.buyerId;
        data["buyerName"] = this.buyerName;
        data["deliveryAddress"] = this.deliveryAddress;
        data["contactNumber"] = this.contactNumber;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["sellerProfileId"] = this.sellerProfileId;
        data["sellerProfileName"] = this.sellerProfileName;
        super.toJSON(data);
        return data;
    }
}

export interface ISellerOrderSummaryDTO extends IBaseOrderSummaryDTO {
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    deliveryAddress?: string | undefined;
    contactNumber?: string | undefined;
    deliveryInstructions?: string | undefined;
    sellerProfileId?: string | undefined;
    sellerProfileName?: string | undefined;
}

export class UpdateOrderStatusDTO implements IUpdateOrderStatusDTO {
    orderId!: number;
    status!: OrderStatus;
    note?: string | undefined;

    constructor(data?: IUpdateOrderStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateOrderStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateOrderStatusDTO {
    orderId: number;
    status: OrderStatus;
    note?: string | undefined;
}

export class CancelOrderDTO implements ICancelOrderDTO {
    orderId!: number;
    cancellationReason?: string | undefined;

    constructor(data?: ICancelOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): CancelOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }
}

export interface ICancelOrderDTO {
    orderId: number;
    cancellationReason?: string | undefined;
}

export class PagedResultDTOOfOrderLimitedDTO implements IPagedResultDTOOfOrderLimitedDTO {
    items?: OrderLimitedDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfOrderLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderLimitedDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfOrderLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfOrderLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfOrderLimitedDTO {
    items?: OrderLimitedDTO[] | undefined;
    totalNumberOfItems: number;
}

export class OrderLimitedDTO implements IOrderLimitedDTO {
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    sellerName?: string | undefined;
    orderNumber?: string | undefined;
    orderDate!: DateTime;
    orderId!: number;
    totalAmount!: number;
    status!: OrderStatus;
    contactNumber?: string | undefined;
    items?: OrderItemDTO[] | undefined;
    deliveryAddress?: string | undefined;
    deliveryInstructions?: string | undefined;
    cancellationReason?: string | undefined;

    constructor(data?: IOrderLimitedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyerId = _data["buyerId"];
            this.buyerName = _data["buyerName"];
            this.sellerName = _data["sellerName"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? DateTime.fromISO(_data["orderDate"].toString()) : undefined as any;
            this.orderId = _data["orderId"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.contactNumber = _data["contactNumber"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDTO.fromJS(item));
            }
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): OrderLimitedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLimitedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyerId"] = this.buyerId;
        data["buyerName"] = this.buyerName;
        data["sellerName"] = this.sellerName;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toString() : undefined as any;
        data["orderId"] = this.orderId;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["contactNumber"] = this.contactNumber;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }
}

export interface IOrderLimitedDTO {
    buyerId?: string | undefined;
    buyerName?: string | undefined;
    sellerName?: string | undefined;
    orderNumber?: string | undefined;
    orderDate: DateTime;
    orderId: number;
    totalAmount: number;
    status: OrderStatus;
    contactNumber?: string | undefined;
    items?: OrderItemDTO[] | undefined;
    deliveryAddress?: string | undefined;
    deliveryInstructions?: string | undefined;
    cancellationReason?: string | undefined;
}

export class OTPRequestDTO implements IOTPRequestDTO {
    phoneNumber!: string;
    isForRegistration!: boolean;

    constructor(data?: IOTPRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.isForRegistration = _data["isForRegistration"];
        }
    }

    static fromJS(data: any): OTPRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OTPRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["isForRegistration"] = this.isForRegistration;
        return data;
    }
}

export interface IOTPRequestDTO {
    phoneNumber: string;
    isForRegistration: boolean;
}

export class OTPVerificationDTO implements IOTPVerificationDTO {
    phoneNumber!: string;
    otpCode!: string;

    constructor(data?: IOTPVerificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.otpCode = _data["otpCode"];
        }
    }

    static fromJS(data: any): OTPVerificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OTPVerificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["otpCode"] = this.otpCode;
        return data;
    }
}

export interface IOTPVerificationDTO {
    phoneNumber: string;
    otpCode: string;
}

export class PrivacyPolicyDTO implements IPrivacyPolicyDTO {
    id!: number;
    name?: string | undefined;
    policyContent?: string | undefined;
    version?: string | undefined;
    forceReacceptance!: boolean;
    createdOn!: DateTime;
    modifiedOn!: DateTime;

    constructor(data?: IPrivacyPolicyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.policyContent = _data["policyContent"];
            this.version = _data["version"];
            this.forceReacceptance = _data["forceReacceptance"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PrivacyPolicyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrivacyPolicyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["policyContent"] = this.policyContent;
        data["version"] = this.version;
        data["forceReacceptance"] = this.forceReacceptance;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IPrivacyPolicyDTO {
    id: number;
    name?: string | undefined;
    policyContent?: string | undefined;
    version?: string | undefined;
    forceReacceptance: boolean;
    createdOn: DateTime;
    modifiedOn: DateTime;
}

export class CreatePrivacyPolicyDTO implements ICreatePrivacyPolicyDTO {
    name!: string;
    policyContent!: string;
    version!: string;
    forceReacceptance!: boolean;

    constructor(data?: ICreatePrivacyPolicyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.policyContent = _data["policyContent"];
            this.version = _data["version"];
            this.forceReacceptance = _data["forceReacceptance"];
        }
    }

    static fromJS(data: any): CreatePrivacyPolicyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrivacyPolicyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["policyContent"] = this.policyContent;
        data["version"] = this.version;
        data["forceReacceptance"] = this.forceReacceptance;
        return data;
    }
}

export interface ICreatePrivacyPolicyDTO {
    name: string;
    policyContent: string;
    version: string;
    forceReacceptance: boolean;
}

export class UpdatePrivacyPolicyDTO implements IUpdatePrivacyPolicyDTO {
    id!: number;
    name!: string;
    policyContent!: string;
    version!: string;
    forceReacceptance!: boolean;

    constructor(data?: IUpdatePrivacyPolicyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.policyContent = _data["policyContent"];
            this.version = _data["version"];
            this.forceReacceptance = _data["forceReacceptance"];
        }
    }

    static fromJS(data: any): UpdatePrivacyPolicyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrivacyPolicyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["policyContent"] = this.policyContent;
        data["version"] = this.version;
        data["forceReacceptance"] = this.forceReacceptance;
        return data;
    }
}

export interface IUpdatePrivacyPolicyDTO {
    id: number;
    name: string;
    policyContent: string;
    version: string;
    forceReacceptance: boolean;
}

export class UserAcceptanceDTO implements IUserAcceptanceDTO {
    id!: number;
    userId?: string | undefined;
    privacyPolicyId!: number;
    acceptedDate!: DateTime;
    isAccepted!: boolean;
    acceptedVersion?: string | undefined;

    constructor(data?: IUserAcceptanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.privacyPolicyId = _data["privacyPolicyId"];
            this.acceptedDate = _data["acceptedDate"] ? DateTime.fromISO(_data["acceptedDate"].toString()) : undefined as any;
            this.isAccepted = _data["isAccepted"];
            this.acceptedVersion = _data["acceptedVersion"];
        }
    }

    static fromJS(data: any): UserAcceptanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserAcceptanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["privacyPolicyId"] = this.privacyPolicyId;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toString() : undefined as any;
        data["isAccepted"] = this.isAccepted;
        data["acceptedVersion"] = this.acceptedVersion;
        return data;
    }
}

export interface IUserAcceptanceDTO {
    id: number;
    userId?: string | undefined;
    privacyPolicyId: number;
    acceptedDate: DateTime;
    isAccepted: boolean;
    acceptedVersion?: string | undefined;
}

export class ProductDTO implements IProductDTO {
    productId!: number;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    additionalInformation?: string | undefined;
    price!: number;
    discountPrice?: number | undefined;
    quantity!: number;
    originalQuantity!: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categories!: CategorySummaryDTO[];
    images!: ProductImageDTO[];
    deliveryOption!: DeliveryOption;
    createdOn!: DateTime;
    modifiedOn!: DateTime;
    status!: ProductStatus;
    averageRating!: number;
    totalReviews!: number;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    isSellerFavourite!: boolean;

    constructor(data?: IProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categories = [];
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.additionalInformation = _data["additionalInformation"];
            this.price = _data["price"];
            this.discountPrice = _data["discountPrice"];
            this.quantity = _data["quantity"];
            this.originalQuantity = _data["originalQuantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategorySummaryDTO.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ProductImageDTO.fromJS(item));
            }
            this.deliveryOption = _data["deliveryOption"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
            this.status = _data["status"];
            this.averageRating = _data["averageRating"];
            this.totalReviews = _data["totalReviews"];
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.availableUntil = _data["availableUntil"] ? DateTime.fromISO(_data["availableUntil"].toString()) : undefined as any;
            this.isSellerFavourite = _data["isSellerFavourite"];
        }
    }

    static fromJS(data: any): ProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        data["sellerProfileId"] = this.sellerProfileId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["additionalInformation"] = this.additionalInformation;
        data["price"] = this.price;
        data["discountPrice"] = this.discountPrice;
        data["quantity"] = this.quantity;
        data["originalQuantity"] = this.originalQuantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["deliveryOption"] = this.deliveryOption;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        data["status"] = this.status;
        data["averageRating"] = this.averageRating;
        data["totalReviews"] = this.totalReviews;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["availableUntil"] = this.availableUntil ? this.availableUntil.toString() : undefined as any;
        data["isSellerFavourite"] = this.isSellerFavourite;
        return data;
    }
}

export interface IProductDTO {
    productId: number;
    sellerId?: string | undefined;
    sellerName?: string | undefined;
    sellerProfileId?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    additionalInformation?: string | undefined;
    price: number;
    discountPrice?: number | undefined;
    quantity: number;
    originalQuantity: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categories: CategorySummaryDTO[];
    images: ProductImageDTO[];
    deliveryOption: DeliveryOption;
    createdOn: DateTime;
    modifiedOn: DateTime;
    status: ProductStatus;
    averageRating: number;
    totalReviews: number;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    isSellerFavourite: boolean;
}

export enum UnitCategory {
    Weight = 1,
    Volume = 2,
    Length = 3,
    Quantity = 4,
    Area = 5,
}

export class CategorySummaryDTO implements ICategorySummaryDTO {
    categoryId!: number;
    name?: string | undefined;

    constructor(data?: ICategorySummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CategorySummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategorySummaryDTO {
    categoryId: number;
    name?: string | undefined;
}

export class ProductImageDTO implements IProductImageDTO {
    imageId!: number;
    isPrimary!: boolean;
    sortOrder!: number;
    imageUrl?: string | undefined;

    constructor(data?: IProductImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.isPrimary = _data["isPrimary"];
            this.sortOrder = _data["sortOrder"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): ProductImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["isPrimary"] = this.isPrimary;
        data["sortOrder"] = this.sortOrder;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IProductImageDTO {
    imageId: number;
    isPrimary: boolean;
    sortOrder: number;
    imageUrl?: string | undefined;
}

export enum DeliveryOption {
    Delivery = 0,
    Pickup = 1,
    Both = 2,
}

export enum ProductStatus {
    Draft = 0,
    Active = 1,
    SoldOut = 2,
    Deleted = 3,
    InActive = 4,
}

export class PagedResultDTOOfProductDTO implements IPagedResultDTOOfProductDTO {
    items?: ProductDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProductDTO {
    items?: ProductDTO[] | undefined;
    totalNumberOfItems: number;
}

export class CreateProductDTO implements ICreateProductDTO {
    title!: string;
    description?: string | undefined;
    additionalInformation?: string | undefined;
    price!: number;
    discountPrice?: number | undefined;
    quantity!: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categoryIds!: number[];
    images!: ProductImageInputDTO[];
    deliveryOption!: DeliveryOption;
    sellerProfileId?: number | undefined;
    status!: ProductStatus;
    publishImmediately!: boolean;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    tempGuid?: string | undefined;

    constructor(data?: ICreateProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.additionalInformation = _data["additionalInformation"];
            this.price = _data["price"];
            this.discountPrice = _data["discountPrice"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ProductImageInputDTO.fromJS(item));
            }
            this.deliveryOption = _data["deliveryOption"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.status = _data["status"];
            this.publishImmediately = _data["publishImmediately"];
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.availableUntil = _data["availableUntil"] ? DateTime.fromISO(_data["availableUntil"].toString()) : undefined as any;
            this.tempGuid = _data["tempGuid"];
        }
    }

    static fromJS(data: any): CreateProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["additionalInformation"] = this.additionalInformation;
        data["price"] = this.price;
        data["discountPrice"] = this.discountPrice;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["deliveryOption"] = this.deliveryOption;
        data["sellerProfileId"] = this.sellerProfileId;
        data["status"] = this.status;
        data["publishImmediately"] = this.publishImmediately;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["availableUntil"] = this.availableUntil ? this.availableUntil.toString() : undefined as any;
        data["tempGuid"] = this.tempGuid;
        return data;
    }
}

export interface ICreateProductDTO {
    title: string;
    description?: string | undefined;
    additionalInformation?: string | undefined;
    price: number;
    discountPrice?: number | undefined;
    quantity: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categoryIds: number[];
    images: ProductImageInputDTO[];
    deliveryOption: DeliveryOption;
    sellerProfileId?: number | undefined;
    status: ProductStatus;
    publishImmediately: boolean;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    tempGuid?: string | undefined;
}

export class ProductImageInputDTO implements IProductImageInputDTO {
    imageUrl?: string | undefined;
    isPrimary!: boolean;
    sortOrder!: number;

    constructor(data?: IProductImageInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.isPrimary = _data["isPrimary"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ProductImageInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["isPrimary"] = this.isPrimary;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IProductImageInputDTO {
    imageUrl?: string | undefined;
    isPrimary: boolean;
    sortOrder: number;
}

export class UpdateProductDTO implements IUpdateProductDTO {
    productId!: number;
    title?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    discountPrice?: number | undefined;
    additionalInformation?: string | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categoryIds?: number[] | undefined;
    deliveryOption?: DeliveryOption | undefined;
    sellerProfileId?: number | undefined;
    status?: ProductStatus | undefined;
    publishImmediately?: boolean | undefined;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    addImages!: ProductImageInputDTO[];
    removeImageIds!: number[];
    setPrimaryImageId?: number | undefined;

    constructor(data?: IUpdateProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.addImages = [];
            this.removeImageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.discountPrice = _data["discountPrice"];
            this.additionalInformation = _data["additionalInformation"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.deliveryOption = _data["deliveryOption"];
            this.sellerProfileId = _data["sellerProfileId"];
            this.status = _data["status"];
            this.publishImmediately = _data["publishImmediately"];
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.availableUntil = _data["availableUntil"] ? DateTime.fromISO(_data["availableUntil"].toString()) : undefined as any;
            if (Array.isArray(_data["addImages"])) {
                this.addImages = [] as any;
                for (let item of _data["addImages"])
                    this.addImages!.push(ProductImageInputDTO.fromJS(item));
            }
            if (Array.isArray(_data["removeImageIds"])) {
                this.removeImageIds = [] as any;
                for (let item of _data["removeImageIds"])
                    this.removeImageIds!.push(item);
            }
            this.setPrimaryImageId = _data["setPrimaryImageId"];
        }
    }

    static fromJS(data: any): UpdateProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["price"] = this.price;
        data["discountPrice"] = this.discountPrice;
        data["additionalInformation"] = this.additionalInformation;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["deliveryOption"] = this.deliveryOption;
        data["sellerProfileId"] = this.sellerProfileId;
        data["status"] = this.status;
        data["publishImmediately"] = this.publishImmediately;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["availableUntil"] = this.availableUntil ? this.availableUntil.toString() : undefined as any;
        if (Array.isArray(this.addImages)) {
            data["addImages"] = [];
            for (let item of this.addImages)
                data["addImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.removeImageIds)) {
            data["removeImageIds"] = [];
            for (let item of this.removeImageIds)
                data["removeImageIds"].push(item);
        }
        data["setPrimaryImageId"] = this.setPrimaryImageId;
        return data;
    }
}

export interface IUpdateProductDTO {
    productId: number;
    title?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    discountPrice?: number | undefined;
    additionalInformation?: string | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    categoryIds?: number[] | undefined;
    deliveryOption?: DeliveryOption | undefined;
    sellerProfileId?: number | undefined;
    status?: ProductStatus | undefined;
    publishImmediately?: boolean | undefined;
    publishDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    availableUntil?: DateTime | undefined;
    addImages: ProductImageInputDTO[];
    removeImageIds: number[];
    setPrimaryImageId?: number | undefined;
}

export class ProductTemplateDTO implements IProductTemplateDTO {
    templateId!: number;
    sellerId?: string | undefined;
    templateName?: string | undefined;
    description?: string | undefined;
    price!: number;
    defaultPublishQuantity!: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist!: number;
    deliveryOption!: DeliveryOption;
    additionalInformation?: string | undefined;
    categories!: CategorySummaryDTO[];
    images!: ProductTemplateImageDTO[];
    primaryImageUrl?: string | undefined;
    createdOn!: DateTime;
    modifiedOn!: DateTime;

    constructor(data?: IProductTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categories = [];
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.sellerId = _data["sellerId"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.defaultPublishQuantity = _data["defaultPublishQuantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            this.daysToUnlist = _data["daysToUnlist"];
            this.deliveryOption = _data["deliveryOption"];
            this.additionalInformation = _data["additionalInformation"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategorySummaryDTO.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ProductTemplateImageDTO.fromJS(item));
            }
            this.primaryImageUrl = _data["primaryImageUrl"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.modifiedOn = _data["modifiedOn"] ? DateTime.fromISO(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProductTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["sellerId"] = this.sellerId;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["price"] = this.price;
        data["defaultPublishQuantity"] = this.defaultPublishQuantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        data["daysToUnlist"] = this.daysToUnlist;
        data["deliveryOption"] = this.deliveryOption;
        data["additionalInformation"] = this.additionalInformation;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["primaryImageUrl"] = this.primaryImageUrl;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toString() : undefined as any;
        return data;
    }
}

export interface IProductTemplateDTO {
    templateId: number;
    sellerId?: string | undefined;
    templateName?: string | undefined;
    description?: string | undefined;
    price: number;
    defaultPublishQuantity: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist: number;
    deliveryOption: DeliveryOption;
    additionalInformation?: string | undefined;
    categories: CategorySummaryDTO[];
    images: ProductTemplateImageDTO[];
    primaryImageUrl?: string | undefined;
    createdOn: DateTime;
    modifiedOn: DateTime;
}

export class ProductTemplateImageDTO implements IProductTemplateImageDTO {
    imageId!: number;
    isPrimary!: boolean;
    sortOrder!: number;
    imageUrl?: string | undefined;

    constructor(data?: IProductTemplateImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.isPrimary = _data["isPrimary"];
            this.sortOrder = _data["sortOrder"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): ProductTemplateImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTemplateImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["isPrimary"] = this.isPrimary;
        data["sortOrder"] = this.sortOrder;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IProductTemplateImageDTO {
    imageId: number;
    isPrimary: boolean;
    sortOrder: number;
    imageUrl?: string | undefined;
}

export class PagedResultDTOOfProductTemplateSummaryDTO implements IPagedResultDTOOfProductTemplateSummaryDTO {
    items?: ProductTemplateSummaryDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfProductTemplateSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductTemplateSummaryDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProductTemplateSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProductTemplateSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProductTemplateSummaryDTO {
    items?: ProductTemplateSummaryDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ProductTemplateSummaryDTO implements IProductTemplateSummaryDTO {
    templateId!: number;
    templateName?: string | undefined;
    price!: number;
    defaultPublishQuantity!: number;
    primaryImageUrl?: string | undefined;
    imageUrls!: string[];
    createdOn!: DateTime;
    lastModifiedDate!: DateTime;
    categoryName?: string | undefined;

    constructor(data?: IProductTemplateSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageUrls = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.price = _data["price"];
            this.defaultPublishQuantity = _data["defaultPublishQuantity"];
            this.primaryImageUrl = _data["primaryImageUrl"];
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? DateTime.fromISO(_data["lastModifiedDate"].toString()) : undefined as any;
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): ProductTemplateSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTemplateSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["price"] = this.price;
        data["defaultPublishQuantity"] = this.defaultPublishQuantity;
        data["primaryImageUrl"] = this.primaryImageUrl;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toString() : undefined as any;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IProductTemplateSummaryDTO {
    templateId: number;
    templateName?: string | undefined;
    price: number;
    defaultPublishQuantity: number;
    primaryImageUrl?: string | undefined;
    imageUrls: string[];
    createdOn: DateTime;
    lastModifiedDate: DateTime;
    categoryName?: string | undefined;
}

export class CreateProductTemplateDTO implements ICreateProductTemplateDTO {
    templateName!: string;
    description?: string | undefined;
    price!: number;
    defaultPublishQuantity!: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist!: number;
    deliveryOption!: DeliveryOption;
    additionalInformation?: string | undefined;
    categoryIds!: number[];
    images!: ProductTemplateImageInputDTO[];
    tempGuid?: string | undefined;

    constructor(data?: ICreateProductTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.defaultPublishQuantity = _data["defaultPublishQuantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            this.daysToUnlist = _data["daysToUnlist"];
            this.deliveryOption = _data["deliveryOption"];
            this.additionalInformation = _data["additionalInformation"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ProductTemplateImageInputDTO.fromJS(item));
            }
            this.tempGuid = _data["tempGuid"];
        }
    }

    static fromJS(data: any): CreateProductTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["price"] = this.price;
        data["defaultPublishQuantity"] = this.defaultPublishQuantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        data["daysToUnlist"] = this.daysToUnlist;
        data["deliveryOption"] = this.deliveryOption;
        data["additionalInformation"] = this.additionalInformation;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["tempGuid"] = this.tempGuid;
        return data;
    }
}

export interface ICreateProductTemplateDTO {
    templateName: string;
    description?: string | undefined;
    price: number;
    defaultPublishQuantity: number;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist: number;
    deliveryOption: DeliveryOption;
    additionalInformation?: string | undefined;
    categoryIds: number[];
    images: ProductTemplateImageInputDTO[];
    tempGuid?: string | undefined;
}

export class ProductTemplateImageInputDTO implements IProductTemplateImageInputDTO {
    imageUrl?: string | undefined;
    isPrimary!: boolean;
    sortOrder!: number;

    constructor(data?: IProductTemplateImageInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.isPrimary = _data["isPrimary"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ProductTemplateImageInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTemplateImageInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["isPrimary"] = this.isPrimary;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IProductTemplateImageInputDTO {
    imageUrl?: string | undefined;
    isPrimary: boolean;
    sortOrder: number;
}

export class UpdateProductTemplateDTO implements IUpdateProductTemplateDTO {
    templateId!: number;
    templateName?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    defaultPublishQuantity?: number | undefined;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist?: number | undefined;
    deliveryOption?: DeliveryOption | undefined;
    additionalInformation?: string | undefined;
    categoryIds?: number[] | undefined;
    addImages!: ProductTemplateImageInputDTO[];
    removeImageIds!: number[];
    setPrimaryImageId?: number | undefined;

    constructor(data?: IUpdateProductTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.addImages = [];
            this.removeImageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.defaultPublishQuantity = _data["defaultPublishQuantity"];
            this.unit = _data["unit"];
            this.unitValue = _data["unitValue"];
            this.unitType = _data["unitType"];
            this.unitCategory = _data["unitCategory"];
            this.daysToUnlist = _data["daysToUnlist"];
            this.deliveryOption = _data["deliveryOption"];
            this.additionalInformation = _data["additionalInformation"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["addImages"])) {
                this.addImages = [] as any;
                for (let item of _data["addImages"])
                    this.addImages!.push(ProductTemplateImageInputDTO.fromJS(item));
            }
            if (Array.isArray(_data["removeImageIds"])) {
                this.removeImageIds = [] as any;
                for (let item of _data["removeImageIds"])
                    this.removeImageIds!.push(item);
            }
            this.setPrimaryImageId = _data["setPrimaryImageId"];
        }
    }

    static fromJS(data: any): UpdateProductTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["price"] = this.price;
        data["defaultPublishQuantity"] = this.defaultPublishQuantity;
        data["unit"] = this.unit;
        data["unitValue"] = this.unitValue;
        data["unitType"] = this.unitType;
        data["unitCategory"] = this.unitCategory;
        data["daysToUnlist"] = this.daysToUnlist;
        data["deliveryOption"] = this.deliveryOption;
        data["additionalInformation"] = this.additionalInformation;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.addImages)) {
            data["addImages"] = [];
            for (let item of this.addImages)
                data["addImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.removeImageIds)) {
            data["removeImageIds"] = [];
            for (let item of this.removeImageIds)
                data["removeImageIds"].push(item);
        }
        data["setPrimaryImageId"] = this.setPrimaryImageId;
        return data;
    }
}

export interface IUpdateProductTemplateDTO {
    templateId: number;
    templateName?: string | undefined;
    description?: string | undefined;
    price?: number | undefined;
    defaultPublishQuantity?: number | undefined;
    unit?: string | undefined;
    unitValue?: number | undefined;
    unitType?: UnitType | undefined;
    unitCategory?: UnitCategory | undefined;
    daysToUnlist?: number | undefined;
    deliveryOption?: DeliveryOption | undefined;
    additionalInformation?: string | undefined;
    categoryIds?: number[] | undefined;
    addImages: ProductTemplateImageInputDTO[];
    removeImageIds: number[];
    setPrimaryImageId?: number | undefined;
}

export class ProductConflictDTO implements IProductConflictDTO {
    templateId!: number;
    templateName?: string | undefined;
    hasConflict!: boolean;
    existingProductId?: number | undefined;
    existingProductName?: string | undefined;
    existingProductStatus?: ProductStatus | undefined;

    constructor(data?: IProductConflictDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.hasConflict = _data["hasConflict"];
            this.existingProductId = _data["existingProductId"];
            this.existingProductName = _data["existingProductName"];
            this.existingProductStatus = _data["existingProductStatus"];
        }
    }

    static fromJS(data: any): ProductConflictDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductConflictDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["hasConflict"] = this.hasConflict;
        data["existingProductId"] = this.existingProductId;
        data["existingProductName"] = this.existingProductName;
        data["existingProductStatus"] = this.existingProductStatus;
        return data;
    }
}

export interface IProductConflictDTO {
    templateId: number;
    templateName?: string | undefined;
    hasConflict: boolean;
    existingProductId?: number | undefined;
    existingProductName?: string | undefined;
    existingProductStatus?: ProductStatus | undefined;
}

export class PublishProductFromTemplateDTO implements IPublishProductFromTemplateDTO {
    templateId!: number;
    resolutionOption!: ConflictResolutionOption;
    existingProductIdToUpdate?: number | undefined;
    overridePrice?: number | undefined;
    overrideQuantity?: number | undefined;
    sellerProfileId?: number | undefined;

    constructor(data?: IPublishProductFromTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.resolutionOption = _data["resolutionOption"];
            this.existingProductIdToUpdate = _data["existingProductIdToUpdate"];
            this.overridePrice = _data["overridePrice"];
            this.overrideQuantity = _data["overrideQuantity"];
            this.sellerProfileId = _data["sellerProfileId"];
        }
    }

    static fromJS(data: any): PublishProductFromTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublishProductFromTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["resolutionOption"] = this.resolutionOption;
        data["existingProductIdToUpdate"] = this.existingProductIdToUpdate;
        data["overridePrice"] = this.overridePrice;
        data["overrideQuantity"] = this.overrideQuantity;
        data["sellerProfileId"] = this.sellerProfileId;
        return data;
    }
}

export interface IPublishProductFromTemplateDTO {
    templateId: number;
    resolutionOption: ConflictResolutionOption;
    existingProductIdToUpdate?: number | undefined;
    overridePrice?: number | undefined;
    overrideQuantity?: number | undefined;
    sellerProfileId?: number | undefined;
}

export enum ConflictResolutionOption {
    CreateNew = 0,
    UpdateExisting = 1,
}

export class SendPushNotificationDTO implements ISendPushNotificationDTO {
    token!: string;
    pushNotification!: PushNotificationDTO;
    isDataMessage!: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;

    constructor(data?: ISendPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pushNotification = new PushNotificationDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.pushNotification = _data["pushNotification"] ? PushNotificationDTO.fromJS(_data["pushNotification"]) : new PushNotificationDTO();
            this.isDataMessage = _data["isDataMessage"];
            this.channelId = _data["channelId"];
            this.sound = _data["sound"];
        }
    }

    static fromJS(data: any): SendPushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["pushNotification"] = this.pushNotification ? this.pushNotification.toJSON() : undefined as any;
        data["isDataMessage"] = this.isDataMessage;
        data["channelId"] = this.channelId;
        data["sound"] = this.sound;
        return data;
    }
}

export interface ISendPushNotificationDTO {
    token: string;
    pushNotification: PushNotificationDTO;
    isDataMessage: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;
}

export class PushNotificationDTO implements IPushNotificationDTO {
    title!: string;
    body!: string;
    type!: MessageType;
    parameters?: string[] | undefined;

    constructor(data?: IPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): PushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface IPushNotificationDTO {
    title: string;
    body: string;
    type: MessageType;
    parameters?: string[] | undefined;
}

export enum MessageType {
    Undefined = 0,
    Message = 1,
    Warning = 2,
    Reaction = 3,
    Alarm = 4,
}

export class RegistrationIdDTO implements IRegistrationIdDTO {
    registrationId?: string | undefined;

    constructor(data?: IRegistrationIdDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
        }
    }

    static fromJS(data: any): RegistrationIdDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationIdDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        return data;
    }
}

export interface IRegistrationIdDTO {
    registrationId?: string | undefined;
}

export class RegistrationStepOneDTO implements IRegistrationStepOneDTO {
    firstName!: string;
    lastName!: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    receiveNotifications!: boolean;
    hasAcceptedPrivacyPolicy!: boolean;

    constructor(data?: IRegistrationStepOneDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.receiveNotifications = _data["receiveNotifications"];
            this.hasAcceptedPrivacyPolicy = _data["hasAcceptedPrivacyPolicy"];
        }
    }

    static fromJS(data: any): RegistrationStepOneDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStepOneDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : undefined as any;
        data["gender"] = this.gender;
        data["receiveNotifications"] = this.receiveNotifications;
        data["hasAcceptedPrivacyPolicy"] = this.hasAcceptedPrivacyPolicy;
        return data;
    }
}

export interface IRegistrationStepOneDTO {
    firstName: string;
    lastName: string;
    dateOfBirth?: DateTime | undefined;
    gender?: string | undefined;
    receiveNotifications: boolean;
    hasAcceptedPrivacyPolicy: boolean;
}

export class OTPResponseDTO implements IOTPResponseDTO {
    registrationId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IOTPResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): OTPResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OTPResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["message"] = this.message;
        return data;
    }
}

export interface IOTPResponseDTO {
    registrationId?: string | undefined;
    message?: string | undefined;
}

export class PhoneNumberDTO implements IPhoneNumberDTO {
    phoneNumber!: string;

    constructor(data?: IPhoneNumberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PhoneNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IPhoneNumberDTO {
    phoneNumber: string;
}

export class PhoneVerificationDTO implements IPhoneVerificationDTO {
    phoneNumber?: string | undefined;
    isVerified!: boolean;

    constructor(data?: IPhoneVerificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): PhoneVerificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneVerificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface IPhoneVerificationDTO {
    phoneNumber?: string | undefined;
    isVerified: boolean;
}

export class EmailDTO implements IEmailDTO {
    email!: string;

    constructor(data?: IEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailDTO {
    email: string;
}

export class EmailOTPVerificationDTO implements IEmailOTPVerificationDTO {
    email!: string;
    otpCode!: string;

    constructor(data?: IEmailOTPVerificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.otpCode = _data["otpCode"];
        }
    }

    static fromJS(data: any): EmailOTPVerificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailOTPVerificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["otpCode"] = this.otpCode;
        return data;
    }
}

export interface IEmailOTPVerificationDTO {
    email: string;
    otpCode: string;
}

export class RegistrationStepThreeDTO implements IRegistrationStepThreeDTO {
    address!: string;
    city!: string;
    state!: string;
    country!: string;
    postalCode!: string;
    latitude!: number;
    longitude!: number;
    subLocality?: string | undefined;
    locality?: string | undefined;

    constructor(data?: IRegistrationStepThreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.subLocality = _data["subLocality"];
            this.locality = _data["locality"];
        }
    }

    static fromJS(data: any): RegistrationStepThreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStepThreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["subLocality"] = this.subLocality;
        data["locality"] = this.locality;
        return data;
    }
}

export interface IRegistrationStepThreeDTO {
    address: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
    latitude: number;
    longitude: number;
    subLocality?: string | undefined;
    locality?: string | undefined;
}

export class RegistrationStepFourDTO implements IRegistrationStepFourDTO {
    trustUserIds!: string[];

    constructor(data?: IRegistrationStepFourDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.trustUserIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trustUserIds"])) {
                this.trustUserIds = [] as any;
                for (let item of _data["trustUserIds"])
                    this.trustUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RegistrationStepFourDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStepFourDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trustUserIds)) {
            data["trustUserIds"] = [];
            for (let item of this.trustUserIds)
                data["trustUserIds"].push(item);
        }
        return data;
    }
}

export interface IRegistrationStepFourDTO {
    trustUserIds: string[];
}

export class RegistrationStepFiveDTO implements IRegistrationStepFiveDTO {
    password!: string;
    confirmPassword!: string;

    constructor(data?: IRegistrationStepFiveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): RegistrationStepFiveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStepFiveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IRegistrationStepFiveDTO {
    password: string;
    confirmPassword: string;
}

export class AcceptPrivacyPolicyDTO implements IAcceptPrivacyPolicyDTO {
    privacyPolicyId!: number;

    constructor(data?: IAcceptPrivacyPolicyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.privacyPolicyId = _data["privacyPolicyId"];
        }
    }

    static fromJS(data: any): AcceptPrivacyPolicyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptPrivacyPolicyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["privacyPolicyId"] = this.privacyPolicyId;
        return data;
    }
}

export interface IAcceptPrivacyPolicyDTO {
    privacyPolicyId: number;
}

export class UserIdDTO implements IUserIdDTO {
    userId?: string | undefined;

    constructor(data?: IUserIdDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserIdDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserIdDTO {
    userId?: string | undefined;
}

export class UpdateUserInterestedCategoriesDTO implements IUpdateUserInterestedCategoriesDTO {
    categoryIds!: number[];

    constructor(data?: IUpdateUserInterestedCategoriesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserInterestedCategoriesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInterestedCategoriesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserInterestedCategoriesDTO {
    categoryIds: number[];
}

export class RegistrationStatusDTO implements IRegistrationStatusDTO {
    registrationId?: string | undefined;
    status?: string | undefined;
    canContinue!: boolean;
    currentStep!: number;
    totalSteps!: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    isEmailVerified!: boolean;
    lastUpdated?: DateTime | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: IRegistrationStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.status = _data["status"];
            this.canContinue = _data["canContinue"];
            this.currentStep = _data["currentStep"];
            this.totalSteps = _data["totalSteps"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.lastUpdated = _data["lastUpdated"] ? DateTime.fromISO(_data["lastUpdated"].toString()) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): RegistrationStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["status"] = this.status;
        data["canContinue"] = this.canContinue;
        data["currentStep"] = this.currentStep;
        data["totalSteps"] = this.totalSteps;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["isEmailVerified"] = this.isEmailVerified;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toString() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IRegistrationStatusDTO {
    registrationId?: string | undefined;
    status?: string | undefined;
    canContinue: boolean;
    currentStep: number;
    totalSteps: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    isEmailVerified: boolean;
    lastUpdated?: DateTime | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class ClientSalesOverviewDTO implements IClientSalesOverviewDTO {
    activeProducts!: number;
    stockSoldPercentage!: number;
    deliveryPercentage!: number;
    soldRevenue!: number;
    totalInventoryValue!: number;
    revenueTrend!: RevenueTrendDTO[];
    lowStockAlerts!: AlertDTO[];
    expiryAlerts!: AlertDTO[];
    inventoryPerformance!: InventoryPerformanceDTO;
    deliveryPerformance!: DeliveryPerformanceDTO;
    orderStatusBreakdown!: OrderStatusBreakdownDTO;
    topProducts!: TopPerformingProductDTO[];
    productsTable?: PagedResultDTOOfProductSalesTableRowDTO | undefined;

    constructor(data?: IClientSalesOverviewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.revenueTrend = [];
            this.lowStockAlerts = [];
            this.expiryAlerts = [];
            this.inventoryPerformance = new InventoryPerformanceDTO();
            this.deliveryPerformance = new DeliveryPerformanceDTO();
            this.orderStatusBreakdown = new OrderStatusBreakdownDTO();
            this.topProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeProducts = _data["activeProducts"];
            this.stockSoldPercentage = _data["stockSoldPercentage"];
            this.deliveryPercentage = _data["deliveryPercentage"];
            this.soldRevenue = _data["soldRevenue"];
            this.totalInventoryValue = _data["totalInventoryValue"];
            if (Array.isArray(_data["revenueTrend"])) {
                this.revenueTrend = [] as any;
                for (let item of _data["revenueTrend"])
                    this.revenueTrend!.push(RevenueTrendDTO.fromJS(item));
            }
            if (Array.isArray(_data["lowStockAlerts"])) {
                this.lowStockAlerts = [] as any;
                for (let item of _data["lowStockAlerts"])
                    this.lowStockAlerts!.push(AlertDTO.fromJS(item));
            }
            if (Array.isArray(_data["expiryAlerts"])) {
                this.expiryAlerts = [] as any;
                for (let item of _data["expiryAlerts"])
                    this.expiryAlerts!.push(AlertDTO.fromJS(item));
            }
            this.inventoryPerformance = _data["inventoryPerformance"] ? InventoryPerformanceDTO.fromJS(_data["inventoryPerformance"]) : new InventoryPerformanceDTO();
            this.deliveryPerformance = _data["deliveryPerformance"] ? DeliveryPerformanceDTO.fromJS(_data["deliveryPerformance"]) : new DeliveryPerformanceDTO();
            this.orderStatusBreakdown = _data["orderStatusBreakdown"] ? OrderStatusBreakdownDTO.fromJS(_data["orderStatusBreakdown"]) : new OrderStatusBreakdownDTO();
            if (Array.isArray(_data["topProducts"])) {
                this.topProducts = [] as any;
                for (let item of _data["topProducts"])
                    this.topProducts!.push(TopPerformingProductDTO.fromJS(item));
            }
            this.productsTable = _data["productsTable"] ? PagedResultDTOOfProductSalesTableRowDTO.fromJS(_data["productsTable"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientSalesOverviewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSalesOverviewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeProducts"] = this.activeProducts;
        data["stockSoldPercentage"] = this.stockSoldPercentage;
        data["deliveryPercentage"] = this.deliveryPercentage;
        data["soldRevenue"] = this.soldRevenue;
        data["totalInventoryValue"] = this.totalInventoryValue;
        if (Array.isArray(this.revenueTrend)) {
            data["revenueTrend"] = [];
            for (let item of this.revenueTrend)
                data["revenueTrend"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lowStockAlerts)) {
            data["lowStockAlerts"] = [];
            for (let item of this.lowStockAlerts)
                data["lowStockAlerts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.expiryAlerts)) {
            data["expiryAlerts"] = [];
            for (let item of this.expiryAlerts)
                data["expiryAlerts"].push(item ? item.toJSON() : undefined as any);
        }
        data["inventoryPerformance"] = this.inventoryPerformance ? this.inventoryPerformance.toJSON() : undefined as any;
        data["deliveryPerformance"] = this.deliveryPerformance ? this.deliveryPerformance.toJSON() : undefined as any;
        data["orderStatusBreakdown"] = this.orderStatusBreakdown ? this.orderStatusBreakdown.toJSON() : undefined as any;
        if (Array.isArray(this.topProducts)) {
            data["topProducts"] = [];
            for (let item of this.topProducts)
                data["topProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["productsTable"] = this.productsTable ? this.productsTable.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientSalesOverviewDTO {
    activeProducts: number;
    stockSoldPercentage: number;
    deliveryPercentage: number;
    soldRevenue: number;
    totalInventoryValue: number;
    revenueTrend: RevenueTrendDTO[];
    lowStockAlerts: AlertDTO[];
    expiryAlerts: AlertDTO[];
    inventoryPerformance: InventoryPerformanceDTO;
    deliveryPerformance: DeliveryPerformanceDTO;
    orderStatusBreakdown: OrderStatusBreakdownDTO;
    topProducts: TopPerformingProductDTO[];
    productsTable?: PagedResultDTOOfProductSalesTableRowDTO | undefined;
}

export class RevenueTrendDTO implements IRevenueTrendDTO {
    date!: DateTime;
    label?: string | undefined;
    amount!: number;

    constructor(data?: IRevenueTrendDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : undefined as any;
            this.label = _data["label"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): RevenueTrendDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueTrendDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : undefined as any;
        data["label"] = this.label;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IRevenueTrendDTO {
    date: DateTime;
    label?: string | undefined;
    amount: number;
}

export class OrderStatusBreakdownDTO implements IOrderStatusBreakdownDTO {
    pendingCount!: number;
    confirmedCount!: number;
    deliveredCount!: number;
    cancelledCount!: number;

    constructor(data?: IOrderStatusBreakdownDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingCount = _data["pendingCount"];
            this.confirmedCount = _data["confirmedCount"];
            this.deliveredCount = _data["deliveredCount"];
            this.cancelledCount = _data["cancelledCount"];
        }
    }

    static fromJS(data: any): OrderStatusBreakdownDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusBreakdownDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingCount"] = this.pendingCount;
        data["confirmedCount"] = this.confirmedCount;
        data["deliveredCount"] = this.deliveredCount;
        data["cancelledCount"] = this.cancelledCount;
        return data;
    }
}

export interface IOrderStatusBreakdownDTO {
    pendingCount: number;
    confirmedCount: number;
    deliveredCount: number;
    cancelledCount: number;
}

export class TopPerformingProductDTO implements ITopPerformingProductDTO {
    productId!: number;
    productName?: string | undefined;
    soldQuantity!: number;
    revenue!: number;

    constructor(data?: ITopPerformingProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.soldQuantity = _data["soldQuantity"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): TopPerformingProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TopPerformingProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["soldQuantity"] = this.soldQuantity;
        data["revenue"] = this.revenue;
        return data;
    }
}

export interface ITopPerformingProductDTO {
    productId: number;
    productName?: string | undefined;
    soldQuantity: number;
    revenue: number;
}

export class PagedResultDTOOfProductSalesTableRowDTO implements IPagedResultDTOOfProductSalesTableRowDTO {
    items?: ProductSalesTableRowDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfProductSalesTableRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductSalesTableRowDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfProductSalesTableRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfProductSalesTableRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfProductSalesTableRowDTO {
    items?: ProductSalesTableRowDTO[] | undefined;
    totalNumberOfItems: number;
}

export class ProductSalesTableRowDTO implements IProductSalesTableRowDTO {
    productId!: number;
    productName?: string | undefined;
    publishedDate!: DateTime;
    originalQuantity!: number;
    currentStock!: number;
    unitOfMeasure?: string | undefined;
    price!: number;
    soldQuantity!: number;
    numberOfOrders!: number;
    salePercentage!: number;
    daysToExpire!: number;
    amount!: number;
    deliveryPercentage!: number;

    constructor(data?: IProductSalesTableRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.publishedDate = _data["publishedDate"] ? DateTime.fromISO(_data["publishedDate"].toString()) : undefined as any;
            this.originalQuantity = _data["originalQuantity"];
            this.currentStock = _data["currentStock"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.price = _data["price"];
            this.soldQuantity = _data["soldQuantity"];
            this.numberOfOrders = _data["numberOfOrders"];
            this.salePercentage = _data["salePercentage"];
            this.daysToExpire = _data["daysToExpire"];
            this.amount = _data["amount"];
            this.deliveryPercentage = _data["deliveryPercentage"];
        }
    }

    static fromJS(data: any): ProductSalesTableRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSalesTableRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toString() : undefined as any;
        data["originalQuantity"] = this.originalQuantity;
        data["currentStock"] = this.currentStock;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["price"] = this.price;
        data["soldQuantity"] = this.soldQuantity;
        data["numberOfOrders"] = this.numberOfOrders;
        data["salePercentage"] = this.salePercentage;
        data["daysToExpire"] = this.daysToExpire;
        data["amount"] = this.amount;
        data["deliveryPercentage"] = this.deliveryPercentage;
        return data;
    }
}

export interface IProductSalesTableRowDTO {
    productId: number;
    productName?: string | undefined;
    publishedDate: DateTime;
    originalQuantity: number;
    currentStock: number;
    unitOfMeasure?: string | undefined;
    price: number;
    soldQuantity: number;
    numberOfOrders: number;
    salePercentage: number;
    daysToExpire: number;
    amount: number;
    deliveryPercentage: number;
}

export class SalesOverviewFilterDTO implements ISalesOverviewFilterDTO {
    startDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    dateRangeType?: string | undefined;
    sellerId?: string | undefined;
    categoryId?: number | undefined;
    deliveryStatus?: string | undefined;
    expiryDaysRange?: number | undefined;
    productName?: string | undefined;

    constructor(data?: ISalesOverviewFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.dateRangeType = _data["dateRangeType"];
            this.sellerId = _data["sellerId"];
            this.categoryId = _data["categoryId"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.expiryDaysRange = _data["expiryDaysRange"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): SalesOverviewFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOverviewFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["dateRangeType"] = this.dateRangeType;
        data["sellerId"] = this.sellerId;
        data["categoryId"] = this.categoryId;
        data["deliveryStatus"] = this.deliveryStatus;
        data["expiryDaysRange"] = this.expiryDaysRange;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ISalesOverviewFilterDTO {
    startDate?: DateTime | undefined;
    endDate?: DateTime | undefined;
    dateRangeType?: string | undefined;
    sellerId?: string | undefined;
    categoryId?: number | undefined;
    deliveryStatus?: string | undefined;
    expiryDaysRange?: number | undefined;
    productName?: string | undefined;
}

export class SellerProfileDTO implements ISellerProfileDTO {
    id!: number;
    userId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    type?: string | undefined;
    isActive!: boolean;
    defaultDeliveryOption?: string | undefined;
    createdAt!: DateTime;
    updatedAt?: DateTime | undefined;
    categories?: CategoryDTO[] | undefined;

    constructor(data?: ISellerProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.defaultDeliveryOption = _data["defaultDeliveryOption"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? DateTime.fromISO(_data["updatedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SellerProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SellerProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["defaultDeliveryOption"] = this.defaultDeliveryOption;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toString() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISellerProfileDTO {
    id: number;
    userId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    type?: string | undefined;
    isActive: boolean;
    defaultDeliveryOption?: string | undefined;
    createdAt: DateTime;
    updatedAt?: DateTime | undefined;
    categories?: CategoryDTO[] | undefined;
}

export class CreateSellerProfileDTO implements ICreateSellerProfileDTO {
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isActive!: boolean;
    defaultDeliveryOption!: string;
    categoryIds!: number[];

    constructor(data?: ICreateSellerProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.defaultDeliveryOption = _data["defaultDeliveryOption"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSellerProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSellerProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["defaultDeliveryOption"] = this.defaultDeliveryOption;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

export interface ICreateSellerProfileDTO {
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isActive: boolean;
    defaultDeliveryOption: string;
    categoryIds: number[];
}

export class UpdateSellerProfileDTO implements IUpdateSellerProfileDTO {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isActive?: boolean | undefined;
    defaultDeliveryOption?: string | undefined;
    categoryIds?: number[] | undefined;

    constructor(data?: IUpdateSellerProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.defaultDeliveryOption = _data["defaultDeliveryOption"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSellerProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSellerProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["defaultDeliveryOption"] = this.defaultDeliveryOption;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSellerProfileDTO {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isActive?: boolean | undefined;
    defaultDeliveryOption?: string | undefined;
    categoryIds?: number[] | undefined;
}

export class SubscriptionDTO implements ISubscriptionDTO {
    id!: number;
    name?: string | undefined;
    price!: number;
    type!: SubscriptionType;
    isActive!: boolean;
    details?: string | undefined;
    priceType!: SubscriptionPriceType;
    tierLevel!: number;
    userSubscriptionAssignments?: UserSubscriptionAssignmentDTO[] | undefined;

    constructor(data?: ISubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.details = _data["details"];
            this.priceType = _data["priceType"];
            this.tierLevel = _data["tierLevel"];
            if (Array.isArray(_data["userSubscriptionAssignments"])) {
                this.userSubscriptionAssignments = [] as any;
                for (let item of _data["userSubscriptionAssignments"])
                    this.userSubscriptionAssignments!.push(UserSubscriptionAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["details"] = this.details;
        data["priceType"] = this.priceType;
        data["tierLevel"] = this.tierLevel;
        if (Array.isArray(this.userSubscriptionAssignments)) {
            data["userSubscriptionAssignments"] = [];
            for (let item of this.userSubscriptionAssignments)
                data["userSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscriptionDTO {
    id: number;
    name?: string | undefined;
    price: number;
    type: SubscriptionType;
    isActive: boolean;
    details?: string | undefined;
    priceType: SubscriptionPriceType;
    tierLevel: number;
    userSubscriptionAssignments?: UserSubscriptionAssignmentDTO[] | undefined;
}

export enum SubscriptionType {
    Individual = 0,
    Business = 1,
}

export enum SubscriptionPriceType {
    Monthly = 0,
    Annually = 1,
    OneTime = 2,
}

export class UserSubscriptionAssignmentDTO implements IUserSubscriptionAssignmentDTO {
    userId?: string | undefined;
    user?: UserInfoDTO | undefined;
    subscriptionId!: number;
    subscription?: SubscriptionDTO | undefined;
    startDate!: DateTime;
    endDate?: DateTime | undefined;
    price!: number;
    priceType!: SubscriptionPriceType;

    constructor(data?: IUserSubscriptionAssignmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserInfoDTO.fromJS(_data["user"]) : undefined as any;
            this.subscriptionId = _data["subscriptionId"];
            this.subscription = _data["subscription"] ? SubscriptionDTO.fromJS(_data["subscription"]) : undefined as any;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : undefined as any;
            this.price = _data["price"];
            this.priceType = _data["priceType"];
        }
    }

    static fromJS(data: any): UserSubscriptionAssignmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubscriptionAssignmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["subscriptionId"] = this.subscriptionId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toString() : undefined as any;
        data["price"] = this.price;
        data["priceType"] = this.priceType;
        return data;
    }
}

export interface IUserSubscriptionAssignmentDTO {
    userId?: string | undefined;
    user?: UserInfoDTO | undefined;
    subscriptionId: number;
    subscription?: SubscriptionDTO | undefined;
    startDate: DateTime;
    endDate?: DateTime | undefined;
    price: number;
    priceType: SubscriptionPriceType;
}

export class UserInfoDTO implements IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled!: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode!: boolean;
    isPrivacyPolicyAccepted!: boolean;
    requestedDeletionOn?: DateTime | undefined;
    activeSubscriptionId?: number | undefined;
    activeSubscriptionName?: string | undefined;

    constructor(data?: IUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.enabled = _data["enabled"];
            this.accessCode = _data["accessCode"];
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
            this.accessCodeGeneratedOn = _data["accessCodeGeneratedOn"] ? DateTime.fromISO(_data["accessCodeGeneratedOn"].toString()) : undefined as any;
            this.accessCodeUsedOn = _data["accessCodeUsedOn"] ? DateTime.fromISO(_data["accessCodeUsedOn"].toString()) : undefined as any;
            this.permanentAccessCode = _data["permanentAccessCode"];
            this.isPrivacyPolicyAccepted = _data["isPrivacyPolicyAccepted"];
            this.requestedDeletionOn = _data["requestedDeletionOn"] ? DateTime.fromISO(_data["requestedDeletionOn"].toString()) : undefined as any;
            this.activeSubscriptionId = _data["activeSubscriptionId"];
            this.activeSubscriptionName = _data["activeSubscriptionName"];
        }
    }

    static fromJS(data: any): UserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["enabled"] = this.enabled;
        data["accessCode"] = this.accessCode;
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        data["accessCodeGeneratedOn"] = this.accessCodeGeneratedOn ? this.accessCodeGeneratedOn.toString() : undefined as any;
        data["accessCodeUsedOn"] = this.accessCodeUsedOn ? this.accessCodeUsedOn.toString() : undefined as any;
        data["permanentAccessCode"] = this.permanentAccessCode;
        data["isPrivacyPolicyAccepted"] = this.isPrivacyPolicyAccepted;
        data["requestedDeletionOn"] = this.requestedDeletionOn ? this.requestedDeletionOn.toString() : undefined as any;
        data["activeSubscriptionId"] = this.activeSubscriptionId;
        data["activeSubscriptionName"] = this.activeSubscriptionName;
        return data;
    }
}

export interface IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode: boolean;
    isPrivacyPolicyAccepted: boolean;
    requestedDeletionOn?: DateTime | undefined;
    activeSubscriptionId?: number | undefined;
    activeSubscriptionName?: string | undefined;
}

export enum Role {
    None = 0,
    Admin = 1,
    ClientAdmin = 2,
    WebUser = 3,
    MobileUser = 4,
    RestService = 5,
    DeliveryExecutive = 6,
}

export class CreateSubscriptionDTO implements ICreateSubscriptionDTO {
    name?: string | undefined;
    price!: number;
    type!: SubscriptionType;
    isActive!: boolean;
    details?: string | undefined;
    priceType!: SubscriptionPriceType;
    tierLevel!: number;
    userSubscriptionAssignments?: UserSubscriptionAssignmentDTO[] | undefined;

    constructor(data?: ICreateSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.details = _data["details"];
            this.priceType = _data["priceType"];
            this.tierLevel = _data["tierLevel"];
            if (Array.isArray(_data["userSubscriptionAssignments"])) {
                this.userSubscriptionAssignments = [] as any;
                for (let item of _data["userSubscriptionAssignments"])
                    this.userSubscriptionAssignments!.push(UserSubscriptionAssignmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["details"] = this.details;
        data["priceType"] = this.priceType;
        data["tierLevel"] = this.tierLevel;
        if (Array.isArray(this.userSubscriptionAssignments)) {
            data["userSubscriptionAssignments"] = [];
            for (let item of this.userSubscriptionAssignments)
                data["userSubscriptionAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateSubscriptionDTO {
    name?: string | undefined;
    price: number;
    type: SubscriptionType;
    isActive: boolean;
    details?: string | undefined;
    priceType: SubscriptionPriceType;
    tierLevel: number;
    userSubscriptionAssignments?: UserSubscriptionAssignmentDTO[] | undefined;
}

export class PagedResultDTOOfSubscriptionDTO implements IPagedResultDTOOfSubscriptionDTO {
    items?: SubscriptionDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfSubscriptionDTO {
    items?: SubscriptionDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateSubscriptionDTO implements IUpdateSubscriptionDTO {
    id!: number;
    name?: string | undefined;
    price!: number;
    isActive!: boolean;
    details?: string | undefined;
    type!: SubscriptionType;
    priceType!: SubscriptionPriceType;
    tierLevel!: number;

    constructor(data?: IUpdateSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.isActive = _data["isActive"];
            this.details = _data["details"];
            this.type = _data["type"];
            this.priceType = _data["priceType"];
            this.tierLevel = _data["tierLevel"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["isActive"] = this.isActive;
        data["details"] = this.details;
        data["type"] = this.type;
        data["priceType"] = this.priceType;
        data["tierLevel"] = this.tierLevel;
        return data;
    }
}

export interface IUpdateSubscriptionDTO {
    id: number;
    name?: string | undefined;
    price: number;
    isActive: boolean;
    details?: string | undefined;
    type: SubscriptionType;
    priceType: SubscriptionPriceType;
    tierLevel: number;
}

export class PagedResultDTOOfUserInfoDTO implements IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class TrustRelationshipDTO implements ITrustRelationshipDTO {
    id!: number;
    userId?: string | undefined;
    userName?: string | undefined;
    trustedUserId?: string | undefined;
    trustedUserName?: string | undefined;
    status!: string;
    createdOn!: DateTime;
    approvedOn?: DateTime | undefined;
    isFavourite!: boolean;

    constructor(data?: ITrustRelationshipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.trustedUserId = _data["trustedUserId"];
            this.trustedUserName = _data["trustedUserName"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? DateTime.fromISO(_data["approvedOn"].toString()) : undefined as any;
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): TrustRelationshipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrustRelationshipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["trustedUserId"] = this.trustedUserId;
        data["trustedUserName"] = this.trustedUserName;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toString() : undefined as any;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface ITrustRelationshipDTO {
    id: number;
    userId?: string | undefined;
    userName?: string | undefined;
    trustedUserId?: string | undefined;
    trustedUserName?: string | undefined;
    status: string;
    createdOn: DateTime;
    approvedOn?: DateTime | undefined;
    isFavourite: boolean;
}

export class AddTrustDTO implements IAddTrustDTO {
    trustedUserId?: string | undefined;

    constructor(data?: IAddTrustDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trustedUserId = _data["trustedUserId"];
        }
    }

    static fromJS(data: any): AddTrustDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrustDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trustedUserId"] = this.trustedUserId;
        return data;
    }
}

export interface IAddTrustDTO {
    trustedUserId?: string | undefined;
}

export class TrustRemovalDTO implements ITrustRemovalDTO {
    success!: boolean;
    message?: string | undefined;

    constructor(data?: ITrustRemovalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TrustRemovalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrustRemovalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ITrustRemovalDTO {
    success: boolean;
    message?: string | undefined;
}

export class TrustRequestDTO implements ITrustRequestDTO {
    id!: number;
    requesterId?: string | undefined;
    requesterName?: string | undefined;
    targetUserId?: string | undefined;
    targetUserName?: string | undefined;
    status!: string;
    requestedOn!: DateTime;
    approvedOn?: DateTime | undefined;

    constructor(data?: ITrustRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requesterId = _data["requesterId"];
            this.requesterName = _data["requesterName"];
            this.targetUserId = _data["targetUserId"];
            this.targetUserName = _data["targetUserName"];
            this.status = _data["status"];
            this.requestedOn = _data["requestedOn"] ? DateTime.fromISO(_data["requestedOn"].toString()) : undefined as any;
            this.approvedOn = _data["approvedOn"] ? DateTime.fromISO(_data["approvedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TrustRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrustRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requesterId"] = this.requesterId;
        data["requesterName"] = this.requesterName;
        data["targetUserId"] = this.targetUserId;
        data["targetUserName"] = this.targetUserName;
        data["status"] = this.status;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toString() : undefined as any;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toString() : undefined as any;
        return data;
    }
}

export interface ITrustRequestDTO {
    id: number;
    requesterId?: string | undefined;
    requesterName?: string | undefined;
    targetUserId?: string | undefined;
    targetUserName?: string | undefined;
    status: string;
    requestedOn: DateTime;
    approvedOn?: DateTime | undefined;
}

export class SendTrustRequestDTO implements ISendTrustRequestDTO {
    targetUserId?: string | undefined;

    constructor(data?: ISendTrustRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SendTrustRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendTrustRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISendTrustRequestDTO {
    targetUserId?: string | undefined;
}

export class TrustRequestActionDTO implements ITrustRequestActionDTO {
    requestId!: number;

    constructor(data?: ITrustRequestActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): TrustRequestActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrustRequestActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ITrustRequestActionDTO {
    requestId: number;
}

export class UpdateFavouriteDTO implements IUpdateFavouriteDTO {
    isFavourite!: boolean;

    constructor(data?: IUpdateFavouriteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): UpdateFavouriteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFavouriteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IUpdateFavouriteDTO {
    isFavourite: boolean;
}

export class UpdateUserInfoDTO implements IUpdateUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    subscriptionId?: number | undefined;

    constructor(data?: IUpdateUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.enabled = _data["enabled"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): UpdateUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["enabled"] = this.enabled;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IUpdateUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    subscriptionId?: number | undefined;
}

export class CreateUserDTO implements ICreateUserDTO {
    clientId?: number | undefined;
    email!: string;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserDTO {
    clientId?: number | undefined;
    email: string;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
}

export class PhoneLoginDTO implements IPhoneLoginDTO {
    phoneNumber!: string;
    otpCode!: string;
    client_Id!: string;
    client_Secret!: string;
    grant_Type!: string;

    constructor(data?: IPhoneLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.otpCode = _data["otpCode"];
            this.client_Id = _data["client_Id"];
            this.client_Secret = _data["client_Secret"];
            this.grant_Type = _data["grant_Type"];
        }
    }

    static fromJS(data: any): PhoneLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["otpCode"] = this.otpCode;
        data["client_Id"] = this.client_Id;
        data["client_Secret"] = this.client_Secret;
        data["grant_Type"] = this.grant_Type;
        return data;
    }
}

export interface IPhoneLoginDTO {
    phoneNumber: string;
    otpCode: string;
    client_Id: string;
    client_Secret: string;
    grant_Type: string;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDTO {
    oldPassword: string;
    newPassword: string;
}

export class SetPasswordDTO implements ISetPasswordDTO {
    newPassword!: string;
    verificationToken!: string;
    userId!: string;
    forgotPasswordProcess?: boolean | undefined;

    constructor(data?: ISetPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.verificationToken = _data["verificationToken"];
            this.userId = _data["userId"];
            this.forgotPasswordProcess = _data["forgotPasswordProcess"];
        }
    }

    static fromJS(data: any): SetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["verificationToken"] = this.verificationToken;
        data["userId"] = this.userId;
        data["forgotPasswordProcess"] = this.forgotPasswordProcess;
        return data;
    }
}

export interface ISetPasswordDTO {
    newPassword: string;
    verificationToken: string;
    userId: string;
    forgotPasswordProcess?: boolean | undefined;
}

export class ForgotPasswordDTO implements IForgotPasswordDTO {
    username!: string;

    constructor(data?: IForgotPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IForgotPasswordDTO {
    username: string;
}

export class MinimumClientVersionDTO implements IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;

    constructor(data?: IMinimumClientVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumClientVersion = _data["minimumClientVersion"];
        }
    }

    static fromJS(data: any): MinimumClientVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MinimumClientVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumClientVersion"] = this.minimumClientVersion;
        return data;
    }
}

export interface IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;
}

export class SuggestedContactsInputDTO implements ISuggestedContactsInputDTO {
    phoneNumbers!: string[];
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: ISuggestedContactsInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.phoneNumbers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): SuggestedContactsInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestedContactsInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ISuggestedContactsInputDTO {
    phoneNumbers: string[];
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class UserProfileDTO implements IUserProfileDTO {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    language?: string | undefined;
    photoUrl?: string | undefined;
    receiveNotifications!: boolean;
    hasAcceptedPrivacyPolicy!: boolean;
    autoApproveTrustConnections!: boolean;
    clientId?: number | undefined;
    categories!: CategoryDTO[];
    subscription?: SubscriptionDTO | undefined;

    constructor(data?: IUserProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.categories = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.subLocality = _data["subLocality"];
            this.locality = _data["locality"];
            this.language = _data["language"];
            this.photoUrl = _data["photoUrl"];
            this.receiveNotifications = _data["receiveNotifications"];
            this.hasAcceptedPrivacyPolicy = _data["hasAcceptedPrivacyPolicy"];
            this.autoApproveTrustConnections = _data["autoApproveTrustConnections"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDTO.fromJS(item));
            }
            this.subscription = _data["subscription"] ? SubscriptionDTO.fromJS(_data["subscription"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["subLocality"] = this.subLocality;
        data["locality"] = this.locality;
        data["language"] = this.language;
        data["photoUrl"] = this.photoUrl;
        data["receiveNotifications"] = this.receiveNotifications;
        data["hasAcceptedPrivacyPolicy"] = this.hasAcceptedPrivacyPolicy;
        data["autoApproveTrustConnections"] = this.autoApproveTrustConnections;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserProfileDTO {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    language?: string | undefined;
    photoUrl?: string | undefined;
    receiveNotifications: boolean;
    hasAcceptedPrivacyPolicy: boolean;
    autoApproveTrustConnections: boolean;
    clientId?: number | undefined;
    categories: CategoryDTO[];
    subscription?: SubscriptionDTO | undefined;
}

export class UpdateUserProfileDTO implements IUpdateUserProfileDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    receiveNotifications?: boolean | undefined;
    hasAcceptedPrivacyPolicy?: boolean | undefined;
    autoApproveTrustConnections?: boolean | undefined;

    constructor(data?: IUpdateUserProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.subLocality = _data["subLocality"];
            this.locality = _data["locality"];
            this.receiveNotifications = _data["receiveNotifications"];
            this.hasAcceptedPrivacyPolicy = _data["hasAcceptedPrivacyPolicy"];
            this.autoApproveTrustConnections = _data["autoApproveTrustConnections"];
        }
    }

    static fromJS(data: any): UpdateUserProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["language"] = this.language;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["subLocality"] = this.subLocality;
        data["locality"] = this.locality;
        data["receiveNotifications"] = this.receiveNotifications;
        data["hasAcceptedPrivacyPolicy"] = this.hasAcceptedPrivacyPolicy;
        data["autoApproveTrustConnections"] = this.autoApproveTrustConnections;
        return data;
    }
}

export interface IUpdateUserProfileDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    subLocality?: string | undefined;
    locality?: string | undefined;
    receiveNotifications?: boolean | undefined;
    hasAcceptedPrivacyPolicy?: boolean | undefined;
    autoApproveTrustConnections?: boolean | undefined;
}

export class PhoneUpdateResponseDTO implements IPhoneUpdateResponseDTO {
    message?: string | undefined;
    success!: boolean;
    phoneNumber?: string | undefined;

    constructor(data?: IPhoneUpdateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PhoneUpdateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneUpdateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IPhoneUpdateResponseDTO {
    message?: string | undefined;
    success: boolean;
    phoneNumber?: string | undefined;
}

export class UpdatePhoneNumberDTO implements IUpdatePhoneNumberDTO {
    phoneNumber?: string | undefined;

    constructor(data?: IUpdatePhoneNumberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdatePhoneNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneNumberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUpdatePhoneNumberDTO {
    phoneNumber?: string | undefined;
}

export class VerifyPhoneUpdateDTO implements IVerifyPhoneUpdateDTO {
    phoneNumber?: string | undefined;
    otpCode?: string | undefined;

    constructor(data?: IVerifyPhoneUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.otpCode = _data["otpCode"];
        }
    }

    static fromJS(data: any): VerifyPhoneUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["otpCode"] = this.otpCode;
        return data;
    }
}

export interface IVerifyPhoneUpdateDTO {
    phoneNumber?: string | undefined;
    otpCode?: string | undefined;
}

export class ModifyUserInterestedCategoryDTO implements IModifyUserInterestedCategoryDTO {
    categoryId!: number;

    constructor(data?: IModifyUserInterestedCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): ModifyUserInterestedCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyUserInterestedCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IModifyUserInterestedCategoryDTO {
    categoryId: number;
}

export class UserSubscriptionDetailsDTO implements IUserSubscriptionDetailsDTO {
    planName?: string | undefined;
    priceType!: SubscriptionPriceType;
    startDate!: DateTime;
    nextBillingDate?: DateTime | undefined;
    isActive!: boolean;
    price!: number;

    constructor(data?: IUserSubscriptionDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planName = _data["planName"];
            this.priceType = _data["priceType"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : undefined as any;
            this.nextBillingDate = _data["nextBillingDate"] ? DateTime.fromISO(_data["nextBillingDate"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UserSubscriptionDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubscriptionDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planName"] = this.planName;
        data["priceType"] = this.priceType;
        data["startDate"] = this.startDate ? this.startDate.toString() : undefined as any;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toString() : undefined as any;
        data["isActive"] = this.isActive;
        data["price"] = this.price;
        return data;
    }
}

export interface IUserSubscriptionDetailsDTO {
    planName?: string | undefined;
    priceType: SubscriptionPriceType;
    startDate: DateTime;
    nextBillingDate?: DateTime | undefined;
    isActive: boolean;
    price: number;
}

export class UserInvoiceListDTO implements IUserInvoiceListDTO {
    id!: number;
    invoiceNumber!: string;
    invoiceDate!: DateTime;
    billingPeriodStart!: DateTime;
    billingPeriodEnd!: DateTime;
    totalAmount!: number;
    status!: InvoiceStatus;
    dueDate?: DateTime | undefined;
    isOverdue!: boolean;

    constructor(data?: IUserInvoiceListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : undefined as any;
            this.billingPeriodStart = _data["billingPeriodStart"] ? DateTime.fromISO(_data["billingPeriodStart"].toString()) : undefined as any;
            this.billingPeriodEnd = _data["billingPeriodEnd"] ? DateTime.fromISO(_data["billingPeriodEnd"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : undefined as any;
            this.isOverdue = _data["isOverdue"];
        }
    }

    static fromJS(data: any): UserInvoiceListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvoiceListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : undefined as any;
        data["billingPeriodStart"] = this.billingPeriodStart ? this.billingPeriodStart.toString() : undefined as any;
        data["billingPeriodEnd"] = this.billingPeriodEnd ? this.billingPeriodEnd.toString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : undefined as any;
        data["isOverdue"] = this.isOverdue;
        return data;
    }
}

export interface IUserInvoiceListDTO {
    id: number;
    invoiceNumber: string;
    invoiceDate: DateTime;
    billingPeriodStart: DateTime;
    billingPeriodEnd: DateTime;
    totalAmount: number;
    status: InvoiceStatus;
    dueDate?: DateTime | undefined;
    isOverdue: boolean;
}

export class UserPaymentHistoryDTO implements IUserPaymentHistoryDTO {
    paymentDate!: DateTime;
    amount!: number;
    invoiceNumber!: string;
    paymentMethod!: PaymentMethod;
    transactionReference?: string | undefined;

    constructor(data?: IUserPaymentHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? DateTime.fromISO(_data["paymentDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.paymentMethod = _data["paymentMethod"];
            this.transactionReference = _data["transactionReference"];
        }
    }

    static fromJS(data: any): UserPaymentHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toString() : undefined as any;
        data["amount"] = this.amount;
        data["invoiceNumber"] = this.invoiceNumber;
        data["paymentMethod"] = this.paymentMethod;
        data["transactionReference"] = this.transactionReference;
        return data;
    }
}

export interface IUserPaymentHistoryDTO {
    paymentDate: DateTime;
    amount: number;
    invoiceNumber: string;
    paymentMethod: PaymentMethod;
    transactionReference?: string | undefined;
}

export class OfF__AnonymousType7OfStringAndStringAndString implements IOfF__AnonymousType7OfStringAndStringAndString {
    version?: string | undefined;
    build?: string | undefined;
    deploymentName?: string | undefined;

    constructor(data?: IOfF__AnonymousType7OfStringAndStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.build = _data["build"];
            this.deploymentName = _data["deploymentName"];
        }
    }

    static fromJS(data: any): OfF__AnonymousType7OfStringAndStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new OfF__AnonymousType7OfStringAndStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["build"] = this.build;
        data["deploymentName"] = this.deploymentName;
        return data;
    }
}

export interface IOfF__AnonymousType7OfStringAndStringAndString {
    version?: string | undefined;
    build?: string | undefined;
    deploymentName?: string | undefined;
}

export class Headers implements IHeaders {

    [key: string]: any;

    constructor(data?: IHeaders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers {
        data = typeof data === 'object' ? data : {};
        let result = new Headers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders {

    [key: string]: any;
}

export class Headers2 implements IHeaders2 {

    [key: string]: any;

    constructor(data?: IHeaders2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers2 {
        data = typeof data === 'object' ? data : {};
        let result = new Headers2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders2 {

    [key: string]: any;
}

export class Headers3 implements IHeaders3 {

    [key: string]: any;

    constructor(data?: IHeaders3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Headers3 {
        data = typeof data === 'object' ? data : {};
        let result = new Headers3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IHeaders3 {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}